export default {
  "messages": {
    "payment_terms": "Payment terms:",
    "primary_contact": "Primary contact:",
    "outstanding_invoices": "Outstanding invoices",
    "invoice": "Invoice #",
    "bill_date": "Bill Date",
    "due_date": "Due Date",
    "days_past_due": "Days Past Due",
    "balance_due": "Balance Due",
    "status": "Status",
    "actions": "Actions",
    "draft": "draft",
    "view": "View",
    "no_outstanding_posted_bills_for_this_supplier": "No outstanding posted bills for this supplier.",
    "close": "Close",
    "pay_selected_bills": "Pay Selected Bills",
    "payment_date": "Payment Date",
    "payment_method": "Payment Method",
    "select_method": "Select method",
    "bank_account": "Bank Account",
    "select_bank_account": "Select bank account",
    "bank_account_required_for_bank_payments": "Bank account required for bank payments.",
    "reference_memo": "Reference / Memo",
    "pay_full_balances": "Pay full balances",
    "supplier": "Supplier",
    "amount_to_pay": "Amount to Pay",
    "no_bills_selected": "No bills selected.",
    "total_to_pay": "Total to pay",
    "cancel": "Cancel",
    "bill_details": "Bill Details",
    "loading_bill_details": "Loading bill details...",
    "description": "Description",
    "qty": "Qty",
    "unit_price": "Unit Price",
    "amount": "Amount",
    "no_line_items_recorded": "No line items recorded.",
    "reference": "Reference",
    "method": "Method",
    "allocated": "Allocated",
    "no_allocations_recorded": "No allocations recorded.",
    "no_bill_found": "No bill found.",
    "vendor": "Vendor",
    "search_suppliers": "Search suppliers...",
    "loading_suppliers": "Loading suppliers...",
    "no_suppliers_found": "No suppliers found.",
    "vendor_is_required": "Vendor is required.",
    "vendor_invoice": "Vendor Invoice #",
    "invoice_number_is_required": "Invoice number is required.",
    "show_all_account_types": "Show all account types",
    "loading_accounts": "Loading accounts...",
    "loading_dimensions": "Loading dimensions...",
    "loading_tax_codes": "Loading tax codes...",
    "tax_codes_failed_to_load_defaulting_to_no_tax": "Tax codes failed to load. Defaulting to No tax.",
    "tax_code": "Tax Code",
    "gl_account": "GL Account",
    "dimension": "Dimension",
    "no_tax": "No tax",
    "tax": "Tax",
    "select_account": "Select account",
    "no_dimension": "No dimension",
    "add_at_least_one_line_with_an_amount": "Add at least one line with an amount.",
    "add_line": "Add Line",
    "total": "Total",
    "notes": "Notes",
    "optional_notes": "Optional notes",
    "saving": "Saving...",
    "record_ap_payment": "Record AP Payment",
    "payment_amount": "Payment Amount",
    "paid_date": "Paid Date",
    "apply": "Apply",
    "allocate": "Allocate",
    "draft_2": "Draft",
    "allocated_total": "Allocated total",
    "unapplied_amount": "Unapplied amount",
    "recording": "Recording...",
    "record_payment": "Record Payment",
    "from": "From",
    "to": "To",
    "generate": "Generate",
    "opening_balance": "Opening Balance",
    "closing_balance": "Closing Balance",
    "bill": "Bill",
    "no_bills_found_for_this_period": "No bills found for this period.",
    "no_payments_found_for_this_period": "No payments found for this period.",
    "select_a_date_range_to_generate_a_statement": "Select a date range to generate a statement.",
    "employee": "Employee",
    "unassigned": "Unassigned",
    "retry": "Retry",
    "generating": "Generating…",
    "generated": "Generated",
    "sending": "Sending…",
    "privana_assist": "Privana Assist",
    "warning": "warning",
    "employees": "Employees",
    "rate": "Rate",
    "calendar": "Calendar",
    "team_member": "Team member",
    "creating": "Creating…",
    "saving_2": "Saving…",
    "cancel_close": "Cancel / Close",
    "save_changes": "Save Changes",
    "profile": "Profile",
    "pending": "pending",
    "currency": "Currency",
    "tax_code_2": "Tax code",
    "audit_trail": "Audit Trail",
    "system": "System",
    "account": "Account",
    "debit": "Debit",
    "credit": "Credit",
    "preview": "Preview",
    "status_filter": "Status filter",
    "all_statuses": "All statuses",
    "submit": "Submit",
    "approve": "Approve",
    "reject": "Reject",
    "save_draft": "Save Draft",
    "loading": "Loading…",
    "adjustments": "Adjustments",
    "working": "Working…",
    "posted": "Posted",
    "next_step": "Next step",
    "publishing": "Publishing…",
    "hide": "Hide",
    "audit_trail_2": "Audit trail",
    "needs_review": "Needs Review",
    "configured": "Configured",
    "default": "Default",
    "edit": "Edit",
    "active": "active",
    "archived": "archived",
    "manual": "Manual",
    "priority": "Priority:",
    "review": "Review",
    "suppliers": "Suppliers",
    "payroll": "Payroll",
    "statement": "Statement",
    "void": "Void",
    "date": "Date",
    "manage": "Manage",
    "payment_amount_2": "Payment amount",
    "select_gl_account": "Select GL account",
    "set_as_default": "Set as default",
    "name": "Name",
    "save": "Save",
    "bank_reconciliation": "Bank Reconciliation",
    "refresh": "Refresh",
    "all_status": "All Status",
    "unmatched": "Unmatched",
    "reviewed_unmatched": "Reviewed (Unmatched)",
    "matched": "Matched",
    "disputed": "Disputed",
    "all": "All",
    "reviewed": "Reviewed",
    "unreviewed": "Unreviewed",
    "bank_reconciliation_settings": "Bank reconciliation settings",
    "edit_bank_accounts": "Edit bank accounts",
    "upload_statement_csv": "Upload statement (CSV)",
    "matched_transactions": "Matched Transactions",
    "automatch_rate": "Auto-Match Rate",
    "reconciliation_session": "Reconciliation Session",
    "not_ready": "Not ready",
    "reviewed_unmatched_2": "Reviewed, unmatched",
    "statement_period": "Statement period",
    "staff": "Staff",
    "bank_transactions": "Bank Transactions",
    "mark_reviewed": "Mark reviewed",
    "mark_unreviewed": "Mark unreviewed",
    "select_all_transactions": "Select all transactions",
    "match_confidence": "Match Confidence",
    "find_match": "Find Match",
    "upload_statement_csv_2": "Upload Statement CSV",
    "choose_csv_file": "Choose CSV file",
    "first_row_is_header": "First row is header",
    "strip_currency_symbols": "Strip currency symbols",
    "parsing_csv": "Parsing CSV...",
    "date_column": "Date column *",
    "select_column": "Select column",
    "description_column": "Description column *",
    "amount_signed": "Amount (signed)",
    "debit_column": "Debit column",
    "credit_column": "Credit column",
    "reference_column": "Reference column",
    "date_format": "Date format",
    "select_format": "Select format",
    "running_balance_column": "Running balance column",
    "direction": "Direction",
    "date_range": "Date range",
    "total_inflows": "Total inflows",
    "total_outflows": "Total outflows",
    "force_import_duplicates": "Force import duplicates",
    "continue": "Continue",
    "import": "Import",
    "view_details": "View details",
    "actual": "Actual",
    "budget": "Budget",
    "difference": "Difference",
    "department": "Department",
    "variance": "Variance",
    "chart_of_accounts": "Chart of Accounts",
    "manage_account_codes_used_in_the_general_ledger": "Manage account codes used in the general ledger.",
    "back_to_general_ledger": "Back to General Ledger",
    "new_account": "New Account",
    "search_by_code_or_name": "Search by code or name",
    "code": "Code",
    "type": "Type",
    "no_accounts_found": "No accounts found.",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "define_the_account_code_and_defaults_for_this_gl_account": "Define the account code and defaults for this GL account.",
    "account_code": "Account Code",
    "account_name": "Account Name",
    "subtype": "Sub-type",
    "optional": "Optional",
    "inactive_accounts_are_hidden_by_default": "Inactive accounts are hidden by default.",
    "manager": "Manager",
    "create": "Create",
    "update": "Update",
    "credit_amount": "Credit Amount",
    "reason": "Reason",
    "refund": "Refund",
    "billing_adjustment": "Billing Adjustment",
    "courtesy_credit": "Courtesy Credit",
    "billing_error": "Billing Error",
    "promotional_credit": "Promotional Credit",
    "detailed_description_of_the_credit": "Detailed description of the credit...",
    "issue_credit": "Issue Credit",
    "dimensions": "Dimensions",
    "manage_reporting_dimensions_for_revenue_and_expenses": "Manage reporting dimensions for revenue and expenses.",
    "new_dimension": "New Dimension",
    "no_dimensions_found": "No dimensions found.",
    "define_the_code_and_name_used_for_reporting_dimensions": "Define the code and name used for reporting dimensions.",
    "type_optional": "Type (optional)",
    "inactive_dimensions_are_hidden_by_default": "Inactive dimensions are hidden by default.",
    "create_report": "Create Report",
    "report_name": "Report Name",
    "report_type": "Report Type",
    "profit_loss": "Profit & Loss",
    "balance_sheet": "Balance Sheet",
    "trial_balance": "Trial Balance",
    "ap_aging": "AP Aging",
    "ar_aging": "AR Aging",
    "budget_vs_actual": "Budget vs Actual",
    "format": "Format",
    "select_budget": "Select budget",
    "budget_version": "Budget Version",
    "select_version": "Select version",
    "date_range_2": "Date Range",
    "start_date": "Start Date",
    "end_date": "End Date",
    "granularity": "Granularity",
    "category": "Category",
    "schedule_this_report": "Schedule this report",
    "frequency": "Frequency",
    "daily": "Daily",
    "weekly": "Weekly",
    "quarterly": "Quarterly",
    "delivery": "Delivery",
    "privana_inbox": "Privana Inbox",
    "email": "Email",
    "save_report": "Save Report",
    "saved_scheduled_reports": "Saved & Scheduled Reports",
    "next_run": "Next Run",
    "run_now": "Run now",
    "download": "Download",
    "no_data_available_for_the_selected_range": "No data available for the selected range.",
    "no_rows_returned_for_this_report_scope": "No rows returned for this report scope.",
    "no_eligible_allocations_found": "No eligible allocations found.",
    "select": "Select",
    "counterparty": "Counterparty",
    "match": "Match",
    "match_full": "Match full",
    "over_allocated": "Over allocated",
    "recommended": "Recommended",
    "member": "Member",
    "no_match_items_selected": "No match items selected.",
    "clear_match": "Clear match",
    "save_match": "Save match",
    "close_checklist": "Close Checklist",
    "no_tasks_configured": "No tasks configured.",
    "staff_2": "staff",
    "save_notes": "Save notes",
    "view_period_events": "View period events",
    "no_events_recorded_for_this_period_yet": "No events recorded for this period yet.",
    "period_actions": "Period Actions",
    "this_period_cannot_be_closed_yet": "This period cannot be closed yet.",
    "close_reason_optional": "Close reason (optional)",
    "close_month": "Close Month",
    "lock_reason_optional": "Lock reason (optional)",
    "required_tasks_incomplete": "Required tasks incomplete",
    "complete_required_tasks_or_provide_an_override_reason_to_lock": "Complete required tasks or provide an override reason to lock this period.",
    "override_reason_required_to_lock": "Override reason (required to lock)",
    "override_lock": "Override & Lock",
    "unlock_reason_required": "Unlock reason (required)",
    "reopen_reason_required": "Reopen reason (required)",
    "close_pack_snapshot": "Close Pack Snapshot",
    "no_snapshots_have_been_run": "No snapshots have been run.",
    "view_report": "View Report",
    "no_activity_recorded_for_this_period": "No activity recorded for this period.",
    "this_trial_balance_contains_no_posted_journal_activity_for_the": "This trial balance contains no posted journal activity for the selected period.",
    "total_debits": "Total Debits",
    "total_credits": "Total Credits",
    "periods": "Periods",
    "monitor_closelock_status_by_fiscal_period": "Monitor close/lock status by fiscal period.",
    "checklist": "Checklist",
    "closed": "Closed",
    "locked": "Locked",
    "loading_periods": "Loading periods...",
    "no_periods_exist_for_this_year": "No periods exist for this year.",
    "blocked_by_earlier_periods": "Blocked by earlier periods",
    "general_ledger_settings": "General Ledger settings",
    "monthend_configuration": "Month-End Configuration",
    "general_ledger": "General Ledger",
    "search_by_account_memo": "Search by account, memo...",
    "close_periods_permission_required": "Close periods permission required",
    "memo": "Memo",
    "loading_entries": "Loading entries...",
    "no_general_ledger_entries_found": "No general ledger entries found.",
    "view_periods": "View periods",
    "loading_invoice": "Loading Invoice...",
    "revenue_was_posted_by_the_operational_source_transactions_before_invoicing": "Revenue was posted by the operational source transactions before invoicing.",
    "gl_posted_via_source_transactions": "GL posted via source transactions",
    "posted_to_gl": "Posted to GL",
    "post_to_gl": "Post to GL",
    "message": "—",
    "billed_to": "Billed to:",
    "issue_date": "Issue Date:",
    "due_date_2": "Due Date:",
    "quantity": "Quantity",
    "search_gl_accounts": "Search GL accounts...",
    "no_gl_account": "No GL account",
    "select_dimension": "Select dimension",
    "search_dimensions": "Search dimensions...",
    "loading_chart_of_accounts": "Loading chart of accounts...",
    "subtotal": "Subtotal:",
    "tax_2": "Tax:",
    "total_2": "Total:",
    "payments": "Payments:",
    "balance_due_2": "Balance Due:",
    "tax_codes_required": "Tax codes required",
    "these_taxable_invoice_lines_do_not_have_a_tax_code": "These taxable invoice lines do not have a tax code selected.",
    "invoice_line": "Invoice line",
    "one_or_more_taxable_invoice_lines_need_a_tax_code": "One or more taxable invoice lines need a tax code before posting.",
    "review_invoice_lines": "Review Invoice Lines",
    "tax_code_gl_mapping_required": "Tax code GL mapping required",
    "this_invoice_cannot_be_posted_to_the_general_ledger_because": "This invoice cannot be posted to the General Ledger because these tax codes are missing an Output VAT GL Account. Go to Club Settings → Accounting → Tax Codes to set the Output VAT GL Account.",
    "line": "line",
    "lines": "lines",
    "one_or_more_taxable_invoice_lines_use_tax_codes_without": "One or more taxable invoice lines use tax codes without an Output VAT GL Account.",
    "fix_tax_code_mappings": "Fix Tax Code Mappings",
    "accounting_settings_required": "Accounting settings required",
    "to_post_this_invoice_complete_the_missing_accounting_defaults": "To post this invoice, complete the missing accounting defaults.",
    "accounting_settings_are_incomplete": "Accounting settings are incomplete.",
    "not_now": "Not now",
    "configure_accounting_settings": "Configure Accounting Settings",
    "accounting_settings": "Accounting Settings",
    "set_the_default_gl_accounts_used_when_posting_invoices": "Set the default GL accounts used when posting invoices.",
    "ar_control_account": "AR Control Account",
    "select_an_account": "Select an account",
    "required_to_post_invoices": "Required to post invoices.",
    "default_revenue_account": "Default Revenue Account",
    "required_when_invoice_lines_are_missing_gl_accounts": "Required when invoice lines are missing GL accounts.",
    "vat_control_account_optional": "VAT Control Account (optional)",
    "required_when_vat_is_applied": "Required when VAT is applied.",
    "create_manual_invoice": "Create Manual Invoice",
    "search_member_name_or": "Search member name or #",
    "issue_date_2": "Issue Date",
    "amounts_are": "Amounts are",
    "exclusive_of_tax": "Exclusive of tax",
    "inclusive_of_tax": "Inclusive of tax",
    "choose_how_unit_prices_are_entered_on_this_invoice": "Choose how unit prices are entered on this invoice.",
    "line_items": "Line Items",
    "loading_categories": "Loading categories...",
    "price": "Price",
    "select_tax_code": "Select Tax Code",
    "tax_exempt": "Tax Exempt",
    "tax_codes_ignored_when_no_tax_is_selected": "Tax codes ignored when “No tax” is selected.",
    "not_effective_for_issue_date": "Not effective for Issue Date.",
    "select_category": "Select category",
    "no_category": "No category",
    "add_item": "Add Item",
    "internal_notes_or_comments_for_the_member": "Internal notes or comments for the member...",
    "save_draft_invoice": "Save Draft Invoice",
    "club_name": "Club Name",
    "club_address": "Club Address",
    "invoice_2": "Invoice",
    "bill_to": "Bill To",
    "subtotal_2": "Subtotal",
    "amount_due": "Amount Due",
    "invoice_preview": "Invoice Preview",
    "member_invoicing": "Member Invoicing",
    "search_member_or_invoice": "Search member or invoice #",
    "paid_credited": "Paid / Credited",
    "no_invoices_found_for_this_club": "No invoices found for this club.",
    "transactions": "Transactions",
    "payment": "Payment",
    "pos_sale": "POS Sale",
    "issued": "Issued",
    "refunded": "Refunded",
    "auto_allocate": "Auto allocate",
    "status_2": "Status:",
    "reason_2": "Reason:",
    "yes": "Yes",
    "no": "No",
    "record_member_payment": "Record Member Payment",
    "unable_to_resolve_a_member_account": "Unable to resolve a member account.",
    "resolving_member_account": "Resolving member account...",
    "received_date": "Received Date",
    "use_pos_cash_float": "Use POS cash float",
    "apply_to_invoices": "Apply to invoices",
    "less_allocated": "Less allocated",
    "remaining_unapplied": "Remaining unapplied",
    "allocate_later_leave_as_credit": "Allocate later (leave as credit)",
    "open_balance": "Open Balance",
    "allocation": "Allocation",
    "no_open_invoices_to_allocate": "No open invoices to allocate.",
    "club_logo": "Club Logo",
    "unit": "Unit",
    "loading_events": "Loading events...",
    "search_staff": "Search staff…",
    "type_at_least_2_characters_to_search": "Type at least 2 characters to search.",
    "searching": "Searching...",
    "no_staff_found": "No staff found.",
    "order": "Order",
    "any": "any",
    "location": "Location",
    "new": "New",
    "credit_card": "Credit Card",
    "cash": "Cash",
    "tax_rate": "Tax Rate (%)",
    "date_2": "Date:",
    "other": "Other",
    "bank_transfer": "Bank Transfer",
    "check": "Check",
    "autopay": "Autopay",
    "reference_number": "Reference Number",
    "check_number_transaction_id_etc": "Check number, transaction ID, etc.",
    "additional_payment_notes": "Additional payment notes...",
    "pending_2": "Pending",
    "member_name": "Member Name",
    "net": "Net",
    "record_receivable_payment": "Record Receivable Payment",
    "debtor": "Debtor:",
    "unlabelled_debtor": "Unlabelled debtor",
    "description_2": "Description:",
    "outstanding": "Outstanding:",
    "previous": "Previous",
    "next": "Next",
    "outstanding_2": "Outstanding",
    "paid": "Paid",
    "source": "Source:",
    "confirm": "Confirm",
    "recipient": "Recipient",
    "pause": "Pause",
    "resume": "Resume",
    "membership_type": "Membership Type",
    "member_2": "member",
    "group": "Group",
    "groups": "Groups",
    "item": "Item",
    "items": "items",
    "scheduled": "scheduled",
    "card": "Card",
    "open": "open",
    "year": "Year",
    "select_member": "Select member",
    "loading_members": "Loading members…",
    "annual": "Annual",
    "payment_terms_2": "Payment Terms",
    "label": "Label",
    "effective_from": "Effective From",
    "select_tax_code_2": "Select tax code",
    "no_tax_code": "No tax code",
    "yearend_assistant": "Year-End Assistant",
    "payroll_trend": "Payroll trend",
    "payroll_sections": "Payroll sections",
    "loading_payroll_data": "Loading payroll data…",
    "payroll_data_could_not_be_loaded": "Payroll data could not be loaded.",
    "no_payroll_records_yet_defaults_are_ready_for_configuration": "No payroll records yet. Defaults are ready for configuration.",
    "payroll_documents": "Payroll Documents",
    "payroll_setup_wizard": "Payroll Setup Wizard",
    "current_payroll_cycle": "Current Payroll Cycle",
    "journal_preview": "Journal Preview",
    "current_payroll_run": "Current Payroll Run",
    "review_payroll": "Review Payroll",
    "payroll_command_centre": "Payroll command centre",
    "no_current_payroll_run": "No current payroll run",
    "create_the_next_payroll_run_to_review_employees_timesheets_blockers": "Create the next payroll run to review employees, timesheets, blockers, approvals, statutory inputs, and accounting in one guided workspace.",
    "create_next_payroll_run": "Create next payroll run",
    "payroll_progress": "Payroll Progress",
    "payroll_readiness": "Payroll Readiness",
    "ready": "Ready",
    "open_details_and_actions": "Open details and actions",
    "privana_assist_will_show_next_actions_when_backend_readiness_checks": "Privana Assist will show next actions when backend readiness checks find something to review.",
    "no_payroll_trend_data_yet": "No payroll trend data yet",
    "department_split_by_gross_pay": "Department split by gross pay",
    "no_department_weighting_yet": "No department weighting yet",
    "payroll_blockers": "Payroll blockers",
    "open_payroll_run": "Open payroll run",
    "no_blockers_found_this_readiness_tile_is_clear": "No blockers found. This readiness tile is clear.",
    "manage_staff_pay_readiness_with_employeefirst_cards": "Manage staff pay readiness with employee-first cards.",
    "search_employees": "Search employees",
    "add_employee": "Add Employee",
    "payroll_employee_actions": "Payroll employee actions",
    "departments": "Departments",
    "bank": "✓ Bank",
    "tax_3": "✓ Tax",
    "pension": "✓ Pension",
    "no_employees_found": "No employees found",
    "archive": "Archive",
    "drop_employees_here": "Drop employees here",
    "done": "Done",
    "people_operations": "People operations",
    "organise_payroll_by_department": "Organise payroll by department",
    "drag_employee_cards_into_teams_or_use_accessible_move_selectors": "Drag employee cards into teams or use accessible move selectors.",
    "loading_departments": "Loading departments…",
    "search_department_employees": "Search department employees",
    "search_people_role_department": "Search people, role, department",
    "new_department_name": "New department name",
    "new_department": "New department",
    "department_colour": "Department colour",
    "staff_link": "Staff Link",
    "staff_member": "Staff member",
    "search_staff_2": "Search staff",
    "search_by_name_email_job_title_or_department": "Search by name, email, job title, or department",
    "clear": "Clear",
    "employment_details": "Employment Details",
    "pay_setup": "Pay Setup",
    "payroll_calculation_rules_for_contractors_will_be_configured_later_this": "Payroll calculation rules for contractors will be configured later; this employee setup only stores the default rate.",
    "readiness_setup": "Readiness Setup",
    "payment_details": "Payment Details",
    "save_payment_details_first_then_mark_them_verified_once_checked": "Save payment details first, then mark them verified once checked.",
    "update_verification": "Update Verification",
    "no_active_payment_details_saved": "No active payment details saved.",
    "enter_full_details_once_existing_sensitive_values_are_never_prefilled": "Enter full details once. Existing sensitive values are never pre-filled when replacing.",
    "cancel_payment_edit": "Cancel Payment Edit",
    "discard_edits": "Discard Edits",
    "edit_profile": "Edit Profile",
    "mark_on_hold": "Mark On Hold",
    "mark_active": "Mark Active",
    "payroll_profile_review": "Payroll Profile Review",
    "edit_mode": "Edit Mode",
    "view_mode": "View Mode",
    "loading_profile_detail": "Loading profile detail…",
    "pay_rate_details": "Pay & Rate Details",
    "effective_from_2": "Effective from",
    "effective_to": "Effective to",
    "active_rate": "Active rate",
    "tax_ni_readiness": "Tax / NI Readiness",
    "ni_number_last4_only": "NI number last4 only",
    "privana_stores_ni_reference_last4_only_full_ni_numbers_are": "Privana stores NI reference last4 only. Full NI numbers are not stored here.",
    "pension_2": "Pension",
    "provider": "Provider",
    "scheme_reference": "Scheme reference",
    "employee_contribution_rate": "Employee contribution rate",
    "employer_contribution_rate": "Employer contribution rate",
    "employer_cost_setup": "Employer Cost Setup",
    "employer_pension_rate": "Employer pension rate",
    "fixed_employer_contribution_override": "Fixed employer contribution override",
    "manual_employer_adjustment_override": "Manual employer adjustment override",
    "manual_adjustment_reason": "Manual adjustment reason",
    "no_audit_history_yet": "No audit history yet.",
    "close_modal": "Close modal",
    "finance_preview": "Finance preview",
    "finance_preview_ready": "Finance Preview Ready",
    "this_payroll_stays_approved_until_it_is_posted_to_accounting": "This payroll stays Approved until it is posted to accounting.",
    "posting_this_payroll_will": "Posting this payroll will:",
    "link_this_payroll_run_to_a_general_ledger_journal": "Link this payroll run to a General Ledger journal",
    "create_outstanding_payroll_hmrc_pension_and_other_payable_obligations": "Create outstanding payroll, HMRC, pension, and other payable obligations",
    "hmrc_payroll_liability_components": "HMRC Payroll Liability components",
    "memo_mapping_key": "Memo / Mapping key",
    "prepare_finance_preview_after_approval": "Prepare finance preview after approval.",
    "payroll_calendar_filter": "Payroll calendar filter",
    "all_calendars": "All calendars",
    "department_filter": "Department filter",
    "department_id": "Department id",
    "period_filter": "Period filter",
    "all_payroll_periods": "All payroll periods",
    "search_timesheets": "Search timesheets",
    "search_employee": "Search employee",
    "new_timesheet": "New Timesheet",
    "import_timesheets": "Import Timesheets",
    "timesheets": "Timesheets",
    "loading_timesheets": "Loading timesheets…",
    "open_2": "Open",
    "reopen": "Reopen",
    "timesheet_lines": "Timesheet Lines",
    "remove_line": "Remove line",
    "create_timesheet": "Create Timesheet",
    "timesheets_are_created_against_payroll_periods_generated_from_payroll_calendar": "Timesheets are created against Payroll Periods generated from Payroll Calendar rules.",
    "no_open_payroll_periods_exist_for_this_calendar_go_to": "No open payroll periods exist for this calendar. Go to Payroll Settings → Payroll Calendars and click Generate Periods.",
    "import_drafts": "Import Drafts",
    "all_periods": "All periods",
    "search_run_name": "Search run name",
    "new_payroll_run": "New Payroll Run",
    "loading_payroll_runs": "Loading payroll runs…",
    "resolve_blockers_before_approval": "Resolve blockers before approval",
    "no_payroll_runs_yet": "No payroll runs yet",
    "statutory_source": "Statutory Source",
    "statutory_payroll_inputs": "Statutory Payroll Inputs",
    "enter_the_providersupplied_statutory_values_for_each_employee_in_this": "Enter the provider-supplied statutory values for each employee in this payroll run.",
    "privana_uses_these_employeelevel_values_to_calculate_net_pay_hmrc": "Privana uses these employee-level values to calculate net pay, HMRC liabilities, payroll clearing, documents, and future payslips.",
    "pension_values_come_from_privana_pension_settings_only_paye_employee": "Pension values come from Privana pension settings. Only PAYE, Employee NI, and Employer NI are entered here.",
    "payroll_was_recalculated_after_statutory_inputs_were_saved_review_and": "Payroll was recalculated after statutory inputs were saved. Review and re-enter statutory values.",
    "previous_statutory_values_are_stale_and_are_not_being_used": "Previous statutory values are stale and are not being used.",
    "optional_sourcereference": "Optional source/reference",
    "optional_reference_eg_payroll_provider_report_name_or_accountant_email": "Optional reference, e.g. payroll provider report name or accountant email.",
    "import_csv_coming_soon": "Import CSV — Coming soon",
    "review_required": "Review required",
    "postedlocked_state_statutory_inputs_are_readonly_postedlocked_runs_show_readonly": "Posted/locked state: statutory inputs are read-only. Posted/locked runs show read-only rows.",
    "save_statutory_inputs": "Save statutory inputs",
    "reset_unsaved_changes": "Reset unsaved changes",
    "create_payroll_run": "Create Payroll Run",
    "payroll_runs_collect_fixed_salary_profiles_approved_timesheets_and_hybrid": "Payroll Runs collect fixed salary profiles, approved timesheets, and hybrid adjustments for the selected payroll period.",
    "include_fixed_salary_profiles": "Include fixed salary profiles",
    "include_timesheetdriven_employees": "Include timesheet-driven employees",
    "include_hybrid_profiles": "Include hybrid profiles",
    "roll_back_stage": "Roll back stage",
    "recalculate_payroll": "Recalculate payroll",
    "posted_to_accounting": "Posted to Accounting",
    "fix_mappings": "Fix mappings",
    "multiple_payroll_journals_were_detected_for_this_payroll_run_review": "Multiple payroll journals were detected for this payroll run. Review before payment.",
    "approval_blockers": "Approval & blockers",
    "opencreate_timesheet": "Open/Create Timesheet",
    "no_blockers_found_payroll_can_move_to_the_next_available": "No blockers found. Payroll can move to the next available step.",
    "publish_payslips_to_staff_portal": "Publish payslips to staff portal?",
    "this_will_make_individual_payslips_available_only_to_staff_included": "This will make individual payslips available only to staff included in this payroll run.",
    "each_staff_member_will_only_be_able_to_view_and": "Each staff member will only be able to view and download their own payslip.",
    "employee_breakdown": "Employee breakdown",
    "no_employee_lines_have_been_calculated_yet": "No employee lines have been calculated yet.",
    "payroll_liabilities": "Payroll liabilities",
    "approvals_pending": "Approvals pending",
    "timesheets_waiting": "Timesheets waiting",
    "payroll_runs_waiting": "Payroll runs waiting",
    "this_item_needs_a_backendlinked_action_before_it_can_be": "This item needs a backend-linked action before it can be opened here.",
    "approvals_clear": "Approvals clear",
    "payroll_liabilities_and_payment_obligations_created_from_payroll_are_shown": "Payroll liabilities and payment obligations created from payroll are shown here. Preview-only items have not created payments or moved money.",
    "no_payroll_liabilities_yet": "No payroll liabilities yet",
    "loading_payroll_settings": "Loading payroll settings…",
    "payroll_calendars": "Payroll Calendars",
    "please_retry": "Please retry.",
    "add_calendar": "Add calendar",
    "payroll_calendars_generate_payroll_periods_timesheets_and_payroll_runs_then": "Payroll calendars generate payroll periods. Timesheets and Payroll Runs then use those generated periods.",
    "loading_payroll_calendars": "Loading payroll calendars…",
    "unable_to_load_payroll_calendars": "Unable to load payroll calendars.",
    "no_payroll_calendars_yet_create_one_to_define_pay_cycles": "No payroll calendars yet. Create one to define pay cycles.",
    "generate_periods": "Generate Periods",
    "set_default": "Set default",
    "weekly_2": "weekly",
    "fortnightly": "fortnightly",
    "monthly": "monthly",
    "quarterly_2": "quarterly",
    "paused": "paused",
    "is_default": "Is default",
    "next_payroll_periods": "Next Payroll Periods",
    "save_calendar_to_preview_generated_periods": "Save calendar to preview generated periods.",
    "pay_rules": "Pay Rules",
    "timesheet_rules": "Timesheet Rules",
    "payroll_setup_policy_centre": "Payroll Setup & Policy Centre",
    "payroll_jurisdiction": "Payroll Jurisdiction",
    "unable_to_determine_payroll_jurisdiction_automatically_please_check_your_club": "⚠ Unable to determine payroll jurisdiction automatically. Please check your club address in Club Settings.",
    "refresh_detection": "Refresh Detection",
    "open_club_settings": "Open Club Settings",
    "advanced_payroll_settings": "Advanced Payroll Settings",
    "for_payroll_specialists_accountants_and_privana_support_these_fields_expose": "For payroll specialists, accountants, and Privana support. These fields expose internal calculation modes, thresholds, rates, mapping keys, jurisdiction settings, and advanced employer cost adjustments.",
    "auto_enrolment_enabled": "Auto enrolment enabled",
    "overtime_enabled": "Overtime enabled",
    "custom": "Custom",
    "standard_hourly_rate": "Standard hourly rate",
    "time_and_a_half_15x": "Time and a half (1.5x)",
    "double_time_20x": "Double time (2.0x)",
    "reset_to_suggested_setting": "Reset to suggested setting",
    "advanced_employer_cost_adjustments": "Advanced Employer Cost Adjustments",
    "accountantlevel_employer_cost_overrides_collapsed_inside_advanced_payroll_settings_for": "Accountant-level employer cost overrides. Collapsed inside Advanced Payroll Settings for everyday club users.",
    "per_run": "Per run",
    "monthly_2": "Monthly",
    "annual_prorated": "Annual prorated",
    "save_payroll_policies": "Save Payroll Policies",
    "privana_assist_controls": "Privana Assist Controls",
    "permissions_preview": "Permissions Preview",
    "role_assignment_will_use_privana_module_permissions_this_preview_does": "Role assignment will use Privana module permissions. This preview does not change permissions yet.",
    "loading_todays_accounting_queue": "Loading today’s accounting queue...",
    "today_workspace": "Today workspace",
    "accounting_today": "Accounting — Today",
    "financial_operations_overview_for_today": "Financial operations overview for today.",
    "no_urgent_financial_actions_today": "No urgent financial actions today.",
    "search_payee_source_or_description": "Search payee, source, or description...",
    "pay_selected": "Pay Selected",
    "add_bill": "Add Bill",
    "all_payables": "All Payables",
    "tax_pension": "Tax & Pension",
    "refunds": "Refunds",
    "other_liabilities": "Other Liabilities",
    "ap_ageing": "AP Ageing",
    "unified_payable_ledger": "Unified Payable Ledger",
    "source_type": "Source Type",
    "payee": "Payee",
    "module": "Module",
    "gl_mapping": "GL Mapping",
    "original_amount": "Original Amount",
    "outstanding_amount": "Outstanding Amount",
    "due_date_run": "Due Date / Run",
    "payment_status": "Payment Status",
    "loading_payables": "Loading payables...",
    "no_payables_found": "No payables found.",
    "view_source": "View Source",
    "recent_ap_payments": "Recent AP Payments",
    "unapplied": "Unapplied",
    "loading_payments": "Loading payments...",
    "no_payments_recorded": "No payments recorded.",
    "current": "Current",
    "totals": "Totals",
    "no_ageing_balances_to_display": "No ageing balances to display.",
    "manage_payment_allocations": "Manage Payment Allocations",
    "current_allocations": "Current allocations",
    "unapply_selected": "Unapply selected",
    "unapply_all": "Unapply all",
    "reallocate_across_bills": "Reallocate across bills",
    "no_open_bills_available_for_reallocation": "No open bills available for reallocation.",
    "reallocation_total": "Reallocation total",
    "apply_reallocation": "Apply reallocation",
    "refund_payment": "Refund payment",
    "refund_amount": "Refund amount",
    "refund_method": "Refund method",
    "refund_date": "Refund date",
    "bank_account_required_for_bank_refunds": "Bank account required for bank refunds.",
    "issue_refund": "Issue refund",
    "add_bank_account": "Add bank account",
    "bank_name": "Bank name",
    "eg_harbor_credit_union": "e.g. Harbor Credit Union",
    "account_name_friendly_label": "Account name (friendly label)",
    "eg_operating_checking": "e.g. Operating Checking",
    "account_number": "Account number",
    "enter_account_number": "Enter account number",
    "eg_usd": "e.g. USD",
    "linked_gl_account_required": "Linked GL account (required)",
    "no_gl_accounts_available": "No GL accounts available.",
    "bank_accounts": "Bank accounts",
    "bank_2": "Bank",
    "linked_gl_account": "Linked GL account",
    "no_bank_accounts_available": "No bank accounts available.",
    "loading_bank_accounts": "Loading bank accounts...",
    "search_transactions": "Search transactions...",
    "income_vs_budget": "Income vs Budget",
    "actual_vs_budget": "Actual vs Budget",
    "expenses_vs_budget": "Expenses vs Budget",
    "income_trend": "Income Trend",
    "expense_trend": "Expense Trend",
    "monthly_performance": "Monthly Performance",
    "period": "Period",
    "of_budget": "% of Budget",
    "department_breakdown": "Department breakdown",
    "variance_2": "Variance %",
    "gl_accounts": "GL Accounts",
    "no_gl_detail_available": "No GL detail available.",
    "inactive": "Inactive",
    "eg_4000": "e.g. 4000",
    "eg_membership_dues": "e.g. Membership Dues",
    "cost_centers_departmental_accounting": "Cost Centers & Departmental Accounting",
    "track_spending_and_budgets_by_department_and_cost_center": "Track spending and budgets by department and cost center",
    "new_cost_center": "New Cost Center",
    "total_cost_centers": "Total Cost Centers",
    "annual_budget": "Annual Budget",
    "ytd_spending": "YTD Spending",
    "budget_variance": "Budget Variance",
    "department_spending_vs_budget": "Department Spending vs Budget",
    "budget_utilization_by_department": "Budget Utilization by Department",
    "cost_centers": "Cost Centers",
    "all_departments": "All Departments",
    "budget_utilization": "Budget Utilization",
    "cost_center_name": "Cost Center Name",
    "eg_fb001": "e.g., FB001",
    "manager_name": "Manager Name",
    "eg_department": "e.g. Department",
    "eg_fnb": "e.g. FNB",
    "eg_food_beverage": "e.g. Food & Beverage",
    "fiscal_year": "Fiscal year",
    "customize_invoice": "Customize Invoice",
    "edit_invoicespecific_presentation_settings_only": "Edit invoice-specific presentation settings only.",
    "billing_email_optional": "Billing Email (optional)",
    "leave_blank_to_use_club_default_in_preview": "Leave blank to use club default in preview",
    "billing_phone_optional": "Billing Phone (optional)",
    "accent_hex_color": "Accent HEX Color",
    "footer_note": "Footer Note",
    "eg_thank_you_for_your_business": "e.g., Thank you for your business!",
    "download_test_pdf": "Download Test PDF",
    "paid_via_direct_payment": "Paid via Direct payment",
    "unbilled": "Unbilled",
    "apply_credit": "Apply Credit",
    "refund_credit": "Refund Credit",
    "available_credit_notes": "Available Credit Notes",
    "available_credit": "Available Credit",
    "current_balance": "Current Balance",
    "open_invoices": "Open Invoices",
    "last_payment": "Last Payment",
    "statements": "Statements",
    "loading_transactions": "Loading transactions…",
    "billing_run": "Billing Run",
    "balance": "Balance",
    "details": "Details",
    "no_transactions_recorded": "No transactions recorded.",
    "view_audit_trail": "View audit trail",
    "reallocate": "Reallocate",
    "refund_payment_2": "Refund Payment",
    "view_credit_note": "View Credit Note",
    "view_invoice": "View Invoice",
    "create_credit_note": "Create Credit Note",
    "no_open_invoices": "No open invoices.",
    "no_invoices_in_this_range": "No invoices in this range.",
    "no_payments_in_this_range": "No payments in this range.",
    "select_a_date_range_to_view_a_statement": "Select a date range to view a statement.",
    "credit_payment": "Credit payment",
    "select_a_payment": "Select a payment",
    "no_open_invoices_available": "No open invoices available.",
    "remaining_credit": "Remaining credit",
    "use_refund_payment_to_reverse_a_receipt_or_payment_allocation": "Use Refund Payment to reverse a receipt or payment allocation. Use Credit Note to reduce an invoice value.",
    "select_invoice": "Select invoice",
    "credit_note_detail": "Credit Note Detail",
    "total_ar": "Total A/R",
    "inactive_accounts": "Inactive Accounts",
    "active_accounts": "Active Accounts",
    "accounts_in_credit": "Accounts in Credit",
    "search_members": "Search members...",
    "filter_by_status": "Filter by status",
    "all_statuses_2": "All Statuses",
    "member_accounts": "Member Accounts",
    "credit_limit": "Credit Limit",
    "credit_balance": "Credit Balance",
    "loading_member_accounts": "Loading member accounts...",
    "no_member_accounts_found": "No member accounts found.",
    "your_logo": "Your Logo",
    "billed_to_2": "Billed To",
    "loading_current_period": "Loading current period...",
    "no_periods_exist_for_this_fiscal_year_yet_generate_periods": "No periods exist for this fiscal year yet. Generate periods to begin month-end close.",
    "go_to_periods": "Go to Periods",
    "no_completed_months_to_close_yet": "No completed months to close yet.",
    "select_a_period_to_continue_the_month_close_workflow": "Select a period to continue the month close workflow.",
    "loading_checklist": "Loading checklist...",
    "action_blocked": "Action blocked",
    "override_reason_required_to_closelock": "Override reason (required to close/lock)",
    "clear_staff_selection": "Clear staff selection",
    "configure_monthend_checklist_templates_exception_policies_and_locking_rules": "Configure month-end checklist templates, exception policies, and locking rules.",
    "you_have_viewonly_access_editing_is_disabled_for_this_configuration": "You have view-only access. Editing is disabled for this configuration.",
    "task_templates": "Task Templates",
    "define_the_checklist_items_required_to_close_a_period": "Define the checklist items required to close a period.",
    "add_task": "Add Task",
    "task": "Task",
    "no_task_templates_configured": "No task templates configured.",
    "task_name": "Task name",
    "exception_policies": "Exception Policies",
    "define_who_can_post_or_delete_entries_during_locked_periods": "Define who can post or delete entries during locked periods.",
    "add_policy": "Add Policy",
    "source_module": "Source Module",
    "optional_limit_this_exception_to_entries_created_by_a_specific": "Optional: limit this exception to entries created by a specific module. Leave as Any to apply to all modules.",
    "entry_class": "Entry Class",
    "entry_class_describes_what_type_of_journal_entry_this_exception": "Entry class describes what type of journal entry this exception applies to (normal, adjusting, reversal, year_end, accrual). Leave as Any to apply to all.",
    "allow_post": "Allow Post",
    "allow_delete": "Allow Delete",
    "no_exception_policies_configured": "No exception policies configured.",
    "locking_rules": "Locking Rules",
    "locking_rules_configuration_coming_soon": "Locking rules configuration coming soon.",
    "todays_sales": "Today's Sales",
    "transactions_today": "Transactions Today",
    "avg_transaction": "Avg Transaction",
    "refunds_today": "Refunds Today",
    "all_locations": "All Locations",
    "new_sale": "New Sale",
    "point_of_sale_transactions": "Point of Sale Transactions",
    "transaction_id": "Transaction ID",
    "datetime": "Date/Time",
    "refunds_returns": "Refunds & Returns",
    "refund_id": "Refund ID",
    "original_transaction": "Original Transaction",
    "member_optional": "Member (Optional)",
    "select_member_or_leave_blank_for_walkin": "Select member or leave blank for walk-in",
    "debit_card": "Debit Card",
    "gift_card": "Gift Card",
    "comp": "Comp",
    "items_2": "Items",
    "item_name": "Item name",
    "tip_amount": "Tip Amount",
    "transaction_notes": "Transaction notes...",
    "process_refund": "Process Refund",
    "refund_amount_2": "Refund Amount",
    "refund_method_2": "Refund Method",
    "account_credit": "Account Credit",
    "reason_for_refund": "Reason for Refund",
    "customer_request": "Customer Request",
    "service_issue": "Service Issue",
    "cancellation": "Cancellation",
    "error_correction": "Error Correction",
    "refund_reason_or_notes": "Refund reason or notes...",
    "total_processed": "Total Processed",
    "failed": "Failed",
    "processing_fees": "Processing Fees",
    "search_payments": "Search payments...",
    "completed": "Completed",
    "invoice_optional": "Invoice (Optional)",
    "select_invoice_to_pay": "Select invoice to pay",
    "additional_notes": "Additional notes...",
    "recent_payments": "Recent Payments",
    "payment_id": "Payment ID",
    "fee": "Fee",
    "no_payments_found": "No payments found",
    "total_receivables": "Total Receivables",
    "outstanding_receivables": "Outstanding Receivables",
    "nonmember_debtors": "Non-member Debtors",
    "all_receivables": "All Receivables",
    "charges": "Charges",
    "billing_status": "Billing Status",
    "no_charges_found": "No charges found.",
    "receivable_detail": "Receivable Detail",
    "debtor_2": "Debtor",
    "original": "Original",
    "source_invoice": "Source & Invoice",
    "accounting_metadata": "Accounting Metadata",
    "settlement_pos_gl_audit": "Settlement, POS & GL Audit",
    "payment_records": "Payment Records",
    "payment_allocations": "Payment Allocations",
    "taxvat_breakdown": "Tax/VAT Breakdown",
    "gl_journal_lines": "GL Journal Lines",
    "invoice_line_items": "Invoice Line Items",
    "go_to_source": "Go to Source",
    "clear_search": "Clear search",
    "search_by_invoice_or_memberdebtor_name": "Search by invoice # or member/debtor name...",
    "no_matching_invoices": "No matching invoices.",
    "use_a_credit_note_to_reduce_the_invoice_value_after": "Use a Credit Note to reduce the invoice value after issue. Use Refund Payment only to return a payment without changing the invoice value.",
    "billing_adjustment_2": "Billing adjustment",
    "goodwillservice_issue": "Goodwill/service issue",
    "event_cancellation": "Event cancellation",
    "membership_adjustment": "Membership adjustment",
    "gross_amount": "Gross amount",
    "post_credit_note_immediately": "Post credit note immediately",
    "enrolment_list": "Enrolment List",
    "billing_runs": "Billing Runs",
    "recurring_billing_settings": "Recurring Billing Settings",
    "billing_cutoff_day_of_month": "Billing cut-off day of month",
    "billing_runs_include_eligible_unbilled_items_up_to_and_including": "Billing runs include eligible unbilled items up to and including the selected cut-off day.",
    "autoemail_recurring_invoices": "Auto-email recurring invoices",
    "invoices_generated_from_recurring_billing_are_emailed_to_members_at": "Invoices generated from recurring billing are emailed to members at 9:00 AM in the club’s local timezone.",
    "generate_invoices": "Generate Invoices",
    "send_invoice": "Send Invoice",
    "statement_total": "Statement Total",
    "current_period": "Current Period",
    "this_will_generate_the_members_invoice_and_email_it_immediately": "This will generate the member's invoice and email it immediately.",
    "the_invoice_will_then_appear_in_invoicing_for": "The invoice will then appear in Invoicing for:",
    "payment_tracking": "payment tracking",
    "overdue_management": "overdue management",
    "future_account_administration": "future account administration",
    "some_items_are_not_mapped_to_accounts": "Some items are not mapped to accounts",
    "unmapped_items_will_not_be_included_in_invoices_unless_you": "Unmapped items will not be included in invoices unless you fix their accounting mappings.",
    "go_to_gl_mapping": "Go to GL Mapping",
    "continue_anyway": "Continue Anyway",
    "membership_dues_enrollment": "Membership Dues Enrollment",
    "accountingonly_enrollment_and_operations_for_recurring_membership_dues": "Accounting-only enrollment and operations for recurring membership dues.",
    "enroll_member": "Enroll Member",
    "active_recurring_dues_enrollments": "Active recurring dues enrollments",
    "enrollment": "Enrollment",
    "enrolled": "Enrolled",
    "not_enrolled": "Not Enrolled",
    "membership_type_2": "Membership type",
    "enroll_selected": "Enroll Selected",
    "generate_invoices_for_selected": "Generate Invoices for Selected",
    "next_run_date": "Next Run Date",
    "latest_invoice": "Latest Invoice",
    "recurring_status": "Recurring Status",
    "generate_invoice_now": "Generate invoice now",
    "run_date": "Run Date",
    "invoices": "Invoices",
    "total_billed": "Total Billed",
    "skipped_warnings": "Skipped / Warnings",
    "view_preview": "View Preview",
    "generate_run": "Generate Run",
    "view_invoices": "View Invoices",
    "record_payments": "Record Payments",
    "loading_billing_runs": "Loading billing runs…",
    "no_billing_runs_yet": "No billing runs yet.",
    "billing_run_detail": "Billing Run Detail",
    "charge": "Charge",
    "generate_billing_run": "Generate billing run?",
    "this_will_create_draft_invoices_for_the_selected_recurring_billing": "This will create draft invoices for the selected recurring billing run period. Draft invoices remain unposted in the general ledger until they are finalized or posted.",
    "statement_preview": "Statement Preview",
    "loading_statement_preview": "Loading statement preview…",
    "dues": "Dues",
    "billing_email": "Billing Email",
    "ready_to_bill": "✓ Ready to Bill",
    "nothing_to_bill": "Nothing to Bill",
    "current_statement": "Current Statement",
    "future_billing": "Future Billing",
    "billing_history": "Billing History",
    "preview_invoice": "Preview Invoice",
    "coming_soon": "Coming Soon",
    "autopay_coming_soon": "Auto-Pay: Coming Soon",
    "statement_preview_summary": "Statement Preview Summary",
    "only_billable_outstanding_items_that_would_be_included_if_generated": "Only billable, outstanding items that would be included if generated now.",
    "no_charges_are_currently_scheduled_for_the_next_statement": "No charges are currently scheduled for the next statement.",
    "charges_included": "Charges Included",
    "paid_settled_voided_and_directly_settled_sales_are_excluded": "Paid, settled, voided, and directly settled sales are excluded.",
    "projected": "Projected",
    "charge_actions": "Charge actions",
    "edit_charge_coming_soon": "Edit Charge — Coming Soon",
    "exclude_this_run": "Exclude This Run",
    "move_to_future_billing_run": "Move to Future Billing Run",
    "make_complimentary_coming_soon": "Make Complimentary — Coming Soon",
    "split_billing_coming_soon": "Split Billing — Coming Soon",
    "add_note_coming_soon": "Add Note — Coming Soon",
    "scheduled_2": "Scheduled",
    "future_charge_actions": "Future charge actions",
    "change_billing_run": "Change Billing Run",
    "no_future_scheduled_charges_found": "No future scheduled charges found.",
    "source_2": "Source",
    "no_previous_billing_periods_found": "No previous billing periods found.",
    "loading_invoice_preview": "Loading invoice preview…",
    "direct_debit": "Direct Debit",
    "charge_source": "Charge Source",
    "source_type_2": "Source type",
    "sale_number": "Sale number",
    "choose_which_billing_run_this_charge_should_appear_in": "Choose which billing run this charge should appear in.",
    "current_billing_run": "Current billing run",
    "billing_runs_2": "Billing runs",
    "custom_2": "Custom...",
    "choose_a_later_billing_run": "Choose a later billing run",
    "month": "Month",
    "custom_billing_month": "Custom billing month",
    "custom_billing_year": "Custom billing year",
    "enroll_member_in_membership_dues": "Enroll Member in Membership Dues",
    "dues_start_date": "Dues Start Date",
    "dues_amount": "Dues Amount",
    "choose_frequency": "Choose frequency",
    "recurring_state": "Recurring State",
    "paused_2": "Paused",
    "autoemail_invoices": "Auto-email invoices",
    "enroll": "Enroll",
    "manage_revenue_payroll_and_future_accounting_mappings_used_by_privana": "Manage revenue, payroll, and future accounting mappings used by Privana posting engines. Configure how operational activity maps into the General Ledger.",
    "show_historical_mappings": "Show Historical Mappings",
    "add_mapping": "Add Mapping",
    "revenue_mappings": "Revenue Mappings",
    "existing_revenue_mapping_rules_used_by_invoice_and_receivables_posting": "Existing revenue mapping rules used by invoice and receivables posting.",
    "loading_gl_mappings": "Loading GL mappings...",
    "key": "Key",
    "no_revenue_mappings_yet": "No revenue mappings yet.",
    "payroll_journal_mappings": "Payroll Journal Mappings",
    "payroll_posting_rules_used_when_payroll_journals_are_generated": "Payroll posting rules used when payroll journals are generated.",
    "mapping_key": "Mapping Key",
    "debit_account": "Debit Account",
    "credit_account": "Credit Account",
    "effective_to_2": "Effective To",
    "no_payroll_journal_mappings_yet_use_accounting_refresh_defaults_to": "No payroll journal mappings yet. Use Accounting Refresh Defaults to repair defaults.",
    "payroll_control_accounts": "Payroll Control Accounts",
    "payroll_liability_and_clearing_accounts_used_by_payroll_posting_and": "Payroll liability and clearing accounts used by payroll posting and Payables handoff.",
    "account_purpose": "Account Purpose",
    "no_payroll_control_accounts_yet_use_accounting_refresh_defaults_to": "No payroll control accounts yet. Use Accounting Refresh Defaults to repair defaults.",
    "refresh_accounting_defaults": "Refresh Accounting Defaults?",
    "this_creates_any_missing_default_accounts_tax_codes_dimensions_revenue": "This creates any missing default accounts, tax codes, dimensions, revenue mappings, and payroll mappings for future transactions only. Historical invoices and journals are not changed.",
    "preparing_your_clubs_accounting_defaults": "Preparing your club’s accounting defaults",
    "were_checking_the_chart_of_accounts_tax_codes_dimensions_revenue": "We’re checking the chart of accounts, tax codes, dimensions, revenue mappings, and payroll mappings so future charges post cleanly. Historical invoices and journals are left untouched.",
    "search_tax_codes": "Search tax codes...",
    "no_tax_codes_found": "No tax codes found.",
    "no_fiscal_years_are_available_yet": "No fiscal years are available yet.",
    "select_fiscal_year": "Select fiscal year",
    "select_a_fiscal_year_to_review_yearend_status": "Select a fiscal year to review year-end status.",
    "loading_yearend_status": "Loading year-end status…",
    "some_modulespecific_checks_were_skipped_because_those_modules_are_not": "Some module-specific checks were skipped because those modules are not enabled or have no activity for this club.",
    "close_fiscal_year": "Close fiscal year",
    "confirm_close": "Confirm close",
    "processing": "Processing...",
    "submit_payment": "Submit Payment",
    "draft_bill": "Draft Bill",
    "edit_bill": "Edit Bill",
    "create_bill": "Create Bill",
    "save_bill": "Save Bill",
    "people": "People",
    "share": "Share",
    "payroll_number": "Payroll Number",
    "employment_type": "Employment Type",
    "job_title": "Job Title",
    "start_year": "Start Year",
    "start_month": "Start Month",
    "start_day": "Start Day",
    "pay_type": "Pay Type",
    "payroll_method": "Payroll Method",
    "payroll_calendar": "Payroll Calendar",
    "bank_readiness": "Bank readiness",
    "taxni_readiness": "Tax/NI readiness",
    "pension_status": "Pension status",
    "payment_details_2": "Payment details",
    "account_type": "Account type",
    "scheme": "Scheme",
    "account_holder": "Account holder",
    "sort_code": "Sort code",
    "reference_last4": "Reference last4",
    "verification_status": "Verification status",
    "last_updated": "Last updated",
    "set_verification_status": "Set verification status",
    "current_rate": "Current Rate",
    "payroll_status": "Payroll Status",
    "readiness_status": "Readiness Status",
    "tax_status": "Tax Status",
    "pension_status_2": "Pension Status",
    "last_paid": "Last Paid",
    "rate_wording": "Rate wording",
    "active_rate_status": "Active rate status",
    "tax_and_ni_details": "Tax and NI details",
    "tax_status_2": "Tax status",
    "ni_last4": "NI last4",
    "employee_contribution": "Employee contribution",
    "employer_contribution": "Employer contribution",
    "pension_enrolled_status": "Pension enrolled status",
    "gb_employer_ni_status": "GB Employer NI status",
    "gross_pay": "Gross pay",
    "net_pay": "Net pay",
    "employer_costs": "Employer costs",
    "total_payroll_cost": "Total payroll cost",
    "total_debits_2": "Total debits",
    "total_credits_2": "Total credits",
    "payroll_period": "Payroll period",
    "sourcereference": "Source/reference",
    "saved_at": "Saved at",
    "saved_by": "Saved by",
    "hmrc_total": "HMRC total",
    "employee_ni": "Employee NI",
    "employer_ni": "Employer NI",
    "source_reference": "Source / reference",
    "net_staff_payments": "Net staff payments",
    "total_cost_to_club": "Total cost to club",
    "payroll_calendar_2": "Payroll calendar",
    "run_name": "Run name",
    "period_rule": "Period rule",
    "generation_horizon_months": "Generation horizon months",
    "pay_date_rule": "Pay date rule",
    "day_of_month": "Day of month",
    "days_after_period_end": "Days after period end",
    "approval_deadline_days": "Approval deadline days",
    "timesheet_cutoff_rule": "Timesheet cutoff rule",
    "cutoff_days": "Cutoff days",
    "overtime_multiplier": "Overtime multiplier",
    "default_currency": "Default currency",
    "timesheet_rounding_mode": "Timesheet rounding mode",
    "calculation_source": "Calculation Source",
    "pension_provider": "Pension provider",
    "employee_contribution_2": "Employee Contribution %",
    "employer_contribution_2": "Employer Contribution %",
    "handled_by": "Handled by",
    "internal_calculation_mode": "Internal calculation mode",
    "liability_mapping_key": "Liability mapping key",
    "expense_mapping_key": "Expense mapping key",
    "jurisdiction_key": "Jurisdiction key",
    "frequency_basis": "Frequency basis",
    "variance_threshold_percent": "Variance threshold percent",
    "post": "Post",
    "debit_gl_account": "Debit GL Account",
    "credit_gl_account": "Credit GL Account",
    "balance_due_3": "Balance due:",
    "issue_credit_memo": "Issue Credit Memo -",
    "save_gl_coding": "Save GL Coding",
    "tax_amount": "Tax amount",
    "account_2": "Account:",
    "applied": "Applied:",
    "record_payment_2": "Record Payment -",
    "wire": "Wire",
    "partially_paid": "Partially Paid",
    "overdue": "Overdue",
    "posting_blocked": "Posting blocked",
    "this_date_falls_in_a_locked_or_closed_period_change": "This date falls in a locked or closed period. Change the date or request an unlock.",
    "posting_failed": "Posting failed",
    "failed_to_post_invoice_to_the_general_ledger": "Failed to post invoice to the general ledger.",
    "failed_to_load_accounting_settings": "Failed to load accounting settings.",
    "unable_to_save_accounting_settings_check_the_account_selections_and": "Unable to save accounting settings. Check the account selections and try again.",
    "ar_control_account_not_set": "AR Control account not set",
    "default_revenue_account_not_set": "Default revenue account not set",
    "vat_control_account_not_set": "VAT control account not set",
    "unable_to_save_line_gl_coding_please_try_again": "Unable to save line GL coding. Please try again.",
    "one_or_more_selected_tax_codes_arent_effective_for_the": "One or more selected tax codes aren’t effective for the invoice Issue Date. Update the Issue Date or choose another tax code.",
    "some_tax_codes_were_not_effective_for_the_selected_issue": "Some tax codes were not effective for the selected Issue Date and were cleared.",
    "cannot_save_no_club_context": "Cannot save: No club context.",
    "failed_to_save_invoice": "Failed to save invoice.",
    "unable_to_record_payment": "Unable to record payment.",
    "finalized": "Finalized",
    "finalize_reconciliation": "Finalize reconciliation",
    "detected_format": "Detected format:",
    "save_account": "Save Account",
    "save_dimension": "Save Dimension",
    "report": "Report",
    "as_of": "As of",
    "confidence": "Confidence",
    "remaining_to_match": "Remaining to match:",
    "required_tasks": "Required tasks",
    "required": "required",
    "optional_2": "optional",
    "paye_income_tax": "PAYE Income Tax:",
    "employee_national_insurance": "Employee National Insurance:",
    "employer_national_insurance": "Employer National Insurance:",
    "hmrc_total_2": "HMRC total:",
    "add_adjustment_scaffold_is_ready_for_a_later_payroll_calculation": "Add Adjustment scaffold is ready for a later payroll calculation pass.",
    "finance_details": "finance details",
    "enabled": "enabled",
    "cost_center": "Cost Center",
    "we_hit_a_snag_rendering_this_report_preview": "We hit a snag rendering this report preview.",
    "try_running_the_report_again_or_adjust_the_date_range": "Try running the report again or adjust the date range. If the issue persists, contact support.",
    "fiscal_month": "Fiscal Month",
    "direct_payment_via_member_portal": "Direct Payment via Member Portal",
    "month_close": "Month Close",
    "pos_transaction": "POS Transaction",
    "transaction": "Transaction",
    "billable": "Billable",
    "recurring_billing_only_activates_when_a_positive_dues_amount_and": "Recurring billing only activates when a positive dues amount and frequency are supplied. Membership type defaults are used by the backend when available; otherwise the values entered here are required.",
    "accounting_refresh_defaults": "Accounting Refresh Defaults",
    "save_mapping": "Save Mapping",
    "all_types": "All types",
    "asset": "Asset",
    "liability": "Liability",
    "equity": "Equity",
    "revenue": "Revenue",
    "expense": "Expense",
    "active_only": "Active only",
    "active_inactive": "Active + Inactive",
    "selected_vendor": "Selected vendor",
    "select_a_vendor": "Select a vendor",
    "supplier_statement": "Supplier Statement",
    "collect": "Collect",
    "outstanding_revenue_requiring_attention": "Outstanding revenue requiring attention",
    "overdue_member_balances": "Overdue member balances",
    "review_balances": "Review balances",
    "due_this_week": "Due this week",
    "open_receivables": "Open receivables",
    "credit_balances_unapplied_cash": "Credit balances & unapplied cash",
    "view_accounts": "View accounts",
    "items_that_need_to_be_posted_into_the_books": "Items that need to be posted into the books",
    "awaiting_posting": "Awaiting posting",
    "open_queue": "Open queue",
    "invoices_awaiting_posting": "Invoices awaiting posting",
    "review_invoices": "Review invoices",
    "ap_bills_awaiting_posting": "A/P bills awaiting posting",
    "review_bills": "Review bills",
    "posting_exceptions": "Posting exceptions",
    "review_exceptions": "Review exceptions",
    "pay": "Pay",
    "supplier_obligations_coming_due": "Supplier obligations coming due",
    "overdue_supplier_bills": "Overdue supplier bills",
    "review_overdue": "Review overdue",
    "due_today": "Due today",
    "open_due_today": "Open due today",
    "review_schedule": "Review schedule",
    "reconcile": "Reconcile",
    "bank_and_control_items_needing_review": "Bank and control items needing review",
    "unmatched_transactions": "Unmatched transactions",
    "reviewed_but_unmatched": "Reviewed but unmatched",
    "continue_review": "Continue review",
    "bank_accounts_unreconciled_this_period": "Bank accounts unreconciled this period",
    "close_controls": "Close / Controls",
    "periodend_tasks_and_blockers": "Period-end tasks and blockers",
    "ar_posting_incomplete": "A/R posting incomplete",
    "ap_posting_incomplete": "A/P posting incomplete",
    "resolve_items": "Resolve items",
    "bank_reconciliation_incomplete": "Bank reconciliation incomplete",
    "open_reconciliation": "Open reconciliation",
    "monthclose_blockers": "Month-close blockers",
    "view_blockers": "View blockers",
    "receivables_outstanding": "Receivables outstanding",
    "supplier_bills_due": "Supplier bills due",
    "posting_issues": "Posting issues",
    "last_updated_time": "Last updated {time}",
    "record_payment_for_member": "Record payment for {member}",
    "issue_credit_memo_for_member": "Issue credit memo for {member}",
    "invoice_number": "Invoice {number}",
    "on_hold": "On Hold",
    "any_3": "Any",
    "all_categories": "All categories",
    "invoiced": "Invoiced",
    "all_departments_2": "All departments",
    "awaiting_approval": "Awaiting approval",
    "exceptions": "Exceptions",
    "accommodation": "Accommodation",
    "normal": "Normal",
    "warning_2": "Warning",
    "import_failed_2": "Import failed",
    "submit_for_approval": "Submit for approval",
    "approval_status": "Approval Status",
    "error_2": "Error",
    "events": "Events",
    "facilities": "Facilities",
    "golf": "Golf",
    "racquet": "Racquet",
    "please_try_again": "Please try again.",
    "benefits": "Benefits",
    "bulk_update_failed": "Bulk update failed",
    "membership": "Membership",
    "accounting": "Accounting",
    "expenses": "Expenses",
    "spa": "Spa",
    "fitness": "Fitness",
    "payables": "Payables",
    "activities": "Activities",
    "pay_date": "Pay date",
    "front_desk": "Front Desk",
    "club": "Club",
    "company": "Company",
    "your_changes_have_been_saved": "Your changes have been saved.",
    "display_name": "Display Name",
    "spa_wellness": "Spa & Wellness",
    "missing": "Missing",
    "please_refresh_and_try_again": "Please refresh and try again.",
    "download_pdf": "Download PDF",
    "invalid_date": "Invalid Date",
    "supplier_not_found": "Supplier not found.",
    "unable_to_load_supplier_ageing_detail": "Unable to load supplier ageing detail.",
    "cheque": "Cheque",
    "select_a_bank_account_for_bank_payments": "Select a bank account for bank payments.",
    "fix_payment_amounts_before_submitting": "Fix payment amounts before submitting.",
    "batch_payment_recorded": "Batch payment recorded.",
    "missing_accounting_defaults": "Missing accounting defaults.",
    "set_ap_control_and_payment_accounts_before_posting": "Set AP control and payment accounts before posting.",
    "failed_to_pay_selected_bills": "Failed to pay selected bills.",
    "failed_to_save_bill": "Failed to save bill.",
    "enter_a_valid_payment_amount": "Enter a valid payment amount.",
    "payment_amount_must_cover_allocations": "Payment amount must cover allocations.",
    "fix_allocation_amounts_before_submitting": "Fix allocation amounts before submitting.",
    "failed_to_record_payment": "Failed to record payment.",
    "no_open_bills_found": "No open bills found.",
    "select_a_vendor_to_view_open_bills": "Select a vendor to view open bills.",
    "loading_4": "Loading...",
    "gross_payroll": "Gross payroll",
    "latest_payroll_total": "Latest payroll total",
    "no_payroll_yet": "No payroll yet",
    "monthly_variance": "Monthly variance",
    "run_another_month_to_compare": "Run another month to compare",
    "higher_than_previous_month": "Higher than previous month",
    "lower_than_previous_month": "Lower than previous month",
    "highest_department_weighting": "Highest department weighting",
    "add_departments_to_compare": "Add departments to compare",
    "not_required_for_run": "Not Required for Run",
    "employee_did_not_work": "Employee Did Not Work",
    "employee_will_be_paid_base_salary_only": "Employee will be paid base salary only.",
    "employee_will_be_included_as_0_pay_only_after_you": "Employee will be included as £0 pay only after you confirm they did not work.",
    "review_before_payroll_can_proceed": "Review before payroll can proceed.",
    "dashboard": "Dashboard",
    "payroll_runs": "Payroll Runs",
    "approvals": "Approvals",
    "liabilities": "Liabilities",
    "settings": "Settings",
    "annual_salary": "Annual Salary",
    "gross_annual_salary_before_deductions": "Gross annual salary before deductions.",
    "hourly_rate": "Hourly Rate",
    "standard_hourly_rate_before_overtime": "Standard hourly rate before overtime.",
    "casual_hourly_rate": "Casual Hourly Rate",
    "default_casual_hourly_rate": "Default casual hourly rate.",
    "contractor_rate": "Contractor Rate",
    "default_contractor_rate_confirm_whether_this_is_hourly_or_dayrate": "Default contractor rate. Confirm whether this is hourly or day-rate before payroll calculation is enabled.",
    "awaiting_approval_2": "Awaiting Approval",
    "approved_2": "Approved",
    "bacs_payment_file": "BACS Payment File",
    "nacha_payment_file": "NACHA Payment File",
    "sepa_payment_file": "SEPA Payment File",
    "bank_payment_file_csv": "Bank Payment File CSV",
    "download_csv": "Download CSV",
    "blocked_statutory_values_stale": "Blocked: statutory values stale",
    "blocked_employeelevel_statutory_values_required": "Blocked: employee-level statutory values required",
    "regenerate_pdf_required": "Regenerate PDF required",
    "ready_to_generate": "Ready to generate",
    "payroll_summary_report": "Payroll Summary report",
    "grosstonet_summary_report": "Gross-to-Net Summary report",
    "employee_breakdown_summary": "Employee Breakdown summary",
    "pension_contributions_summary": "Pension Contributions summary",
    "hmrc_summary_report": "HMRC Summary report",
    "final_payslips": "Final payslips",
    "csv_summary_exports_and_printable_final_payslips_the_bank_payment": "CSV summary exports and printable final payslips. The bank payment file is an export/validation artifact only and never moves money.",
    "generate_payroll_documents": "Generate payroll documents",
    "blocked": "Blocked",
    "not_generated_yet": "Not generated yet",
    "generate_employeespecific_final_payslip_snapshots_before_publishing": "Generate employee-specific final payslip snapshots before publishing.",
    "send_via_portal": "Send via portal",
    "complete_once_to_make_payroll_clubready": "Complete once to make payroll club-ready.",
    "confirm_country": "Confirm Country",
    "choose_payroll_provider": "Choose Payroll Provider",
    "confirm_pension_provider": "Confirm Pension Provider",
    "verify_payroll_calendar": "Verify Payroll Calendar",
    "backenddriven_finance_control_workspace_for_the_active_payroll_run": "Backend-driven finance control workspace for the active payroll run.",
    "current_run_name": "Current run name",
    "pay_period": "Pay period",
    "approval_deadline": "Approval deadline",
    "target_payment_date": "Target payment date",
    "posting_readiness": "Posting readiness",
    "recommendation_create_or_calculate_the_current_payroll_run_before_approval": "Recommendation: create or calculate the current payroll run before approval.",
    "insight_employee_readiness_timesheet_approvals_blockers_and_journal_preview_are": "Insight: employee readiness, timesheet approvals, blockers, and journal preview are loaded from payroll backend data.",
    "plainenglish_checks_based_on_actual_payroll_data": "Plain-English checks based on actual payroll data.",
    "payroll_mapping": "Payroll mapping",
    "preview_only_balanced_journal_lines_appear_after_payroll_approvalpost_preview": "Preview only. Balanced journal lines appear after payroll approval/post preview.",
    "no_journal_preview_yet": "No journal preview yet",
    "create_or_calculate_a_payroll_run": "Create or calculate a payroll run",
    "employees_ready": "Employees Ready",
    "bank_details": "Bank Details",
    "tax_details": "Tax Details",
    "approved_timesheets": "Approved Timesheets",
    "blockers": "Blockers",
    "current_payroll": "Current payroll",
    "period_not_set": "Period not set",
    "gross_pay_2": "Gross Pay",
    "net_preview": "Net Preview",
    "employer_costs_2": "Employer Costs",
    "total_payroll_cost_2": "Total Payroll Cost",
    "where_this_run_is_and_what_happens_next": "Where this run is and what happens next.",
    "backend_checks_that_determine_whether_payroll_can_move_forward": "Backend checks that determine whether payroll can move forward.",
    "needs_attention_2": "Needs attention",
    "no_payroll_trend_data_yet_complete_your_first_payroll_run": "No payroll trend data yet. Complete your first payroll run to start building payroll insights.",
    "latest_payroll_weighting_by_employee_department_employer_costs_are_not": "Latest payroll weighting by employee department. Employer costs are not allocated across departments in V1.",
    "calculate_payroll_with_employee_departments_to_unlock_department_weighting": "Calculate payroll with employee departments to unlock department weighting.",
    "open_payroll_settings": "Open Payroll Settings",
    "open_statutory_payroll_inputs": "Open statutory payroll inputs",
    "open_employee_payroll_profile": "Open employee payroll profile",
    "readiness_details": "Readiness details",
    "review_this_payroll_readiness_item": "Review this payroll readiness item.",
    "payroll_run": "Payroll run",
    "fixed_salary": "Fixed salary",
    "timesheet_required": "Timesheet required",
    "salary_timesheet_adjustments": "Salary + timesheet adjustments",
    "paid_from_the_profile_rate_without_requiring_a_timesheet": "Paid from the profile rate without requiring a timesheet.",
    "paid_from_approved_timesheet_hours_for_each_payroll_period": "Paid from approved timesheet hours for each payroll period.",
    "base_salary_comes_from_the_profile_rate_timesheets_capture_overtimeadjustments": "Base salary comes from the profile rate; timesheets capture overtime/adjustments.",
    "fixed_day_of_month": "Fixed day of month",
    "last_day_of_month": "Last day of month",
    "last_working_day_of_month": "Last working day of month",
    "last_monday_of_month": "Last Monday of month",
    "last_tuesday_of_month": "Last Tuesday of month",
    "last_wednesday_of_month": "Last Wednesday of month",
    "last_thursday_of_month": "Last Thursday of month",
    "last_friday_of_month": "Last Friday of month",
    "missing_bank": "Missing Bank",
    "missing_tax": "Missing Tax",
    "missing_pension": "Missing Pension",
    "unnamed_employee": "Unnamed employee",
    "view_employee": "View Employee",
    "fix_details": "Fix Details",
    "add_an_employee_or_adjust_the_filters": "Add an employee or adjust the filters.",
    "could_not_load_departments": "Could not load departments",
    "could_not_move_employees_the_change_was_reverted": "Could not move employees. The change was reverted.",
    "enter_a_department_name_first": "Enter a department name first.",
    "could_not_create_department": "Could not create department",
    "move_people_here_to_remove_assignment": "Move people here to remove assignment.",
    "drag_people_here_or_use_the_selector": "Drag people here or use the selector.",
    "could_not_archive_department": "Could not archive department",
    "visual_payroll_team_management_avatarled_draganddrop_friendly_no_hierarchy": "Visual payroll team management — avatar-led, drag-and-drop friendly, no hierarchy.",
    "create_department": "Create department",
    "select_a_staff_member_before_creating_the_employee_setup": "Select a staff member before creating the employee setup.",
    "choose_a_pay_type": "Choose a pay type.",
    "choose_a_payroll_status": "Choose a payroll status.",
    "we_could_not_create_this_employee_payroll_setup_please_check": "We could not create this employee payroll setup. Please check the details and try again.",
    "create_employee": "Create Employee",
    "start_with_a_staff_record_then_configure_pay_and_readiness": "Start with a staff record, then configure pay and readiness basics.",
    "no_calendar": "No calendar",
    "bank_payment_details_are_not_configured_for_this_club_jurisdiction": "Bank payment details are not configured for this club jurisdiction yet.",
    "account_holder_name": "Account holder name",
    "payment_reference_optional": "Payment reference (optional)",
    "routing_number": "Routing number",
    "checking": "Checking",
    "savings": "Savings",
    "privana_stores_payroll_payment_details_encrypted_full_details_are_never": "Privana stores payroll payment details encrypted. Full details are never shown again after saving.",
    "replacement_reason": "Replacement reason",
    "replace_payment_details": "Replace Payment Details",
    "add_payment_details": "Add Payment Details",
    "profile_detail_could_not_be_loaded": "Profile detail could not be loaded.",
    "replacement_reason_is_required_when_replacing_payment_details": "Replacement reason is required when replacing payment details.",
    "payment_details_saved_review_the_refreshed_details_then_mark_them": "Payment details saved. Review the refreshed details, then mark them verified once checked.",
    "payroll_profile_changes_saved": "Payroll profile changes saved.",
    "payment_verification_status_updated": "Payment verification status updated.",
    "payment_verification_status_could_not_be_updated": "Payment verification status could not be updated.",
    "status_could_not_be_updated": "Status could not be updated.",
    "payroll_number_pending": "Payroll number pending",
    "no_active_rate": "No active rate",
    "not_paid_yet": "Not paid yet",
    "no_amount_configured": "No amount configured",
    "active_3": "Active",
    "not_active": "Not active",
    "amount_paid_according_to_the_selected_pay_type": "Amount paid according to the selected pay type.",
    "no_full_ni_number_stored": "No full NI number stored.",
    "employeespecific_employer_cost_overrides_are_stored_in_pension_metadata": "Employee-specific employer cost overrides are stored in pension metadata.",
    "audit_event_recorded": "Audit event recorded.",
    "no_records_yet": "No records yet.",
    "hmrcpaye_liability": "HMRC/PAYE Liability",
    "hmrc_payroll_liability": "HMRC Payroll Liability",
    "journal_balanced": "Journal balanced",
    "journal_not_balanced": "Journal not balanced",
    "employer_costs_currently_000": "Employer costs currently £0.00",
    "mapping_needed": "Mapping needed",
    "could_not_load_timesheets": "Could not load timesheets",
    "timesheet_action_failed": "Timesheet action failed",
    "submitted_hours": "Submitted Hours",
    "approved_hours": "Approved Hours",
    "overtime_hours": "Overtime Hours",
    "missing_timesheets": "Missing Timesheets",
    "pending_approvals": "Pending Approvals",
    "approved_timesheets_are_the_operational_input_layer_for_timesheetdriven_and": "Approved timesheets are the operational input layer for timesheet-driven and hybrid employees.",
    "regular_hours": "Regular Hours",
    "overtime": "Overtime",
    "holiday": "Holiday",
    "sick": "Sick",
    "total_hours": "Total Hours",
    "none": "None",
    "could_not_load_timesheet": "Could not load timesheet",
    "could_not_save_draft": "Could not save draft",
    "action_failed_2": "Action failed",
    "timesheet": "Timesheet",
    "regular": "Regular",
    "no_adjustments_yet": "No adjustments yet.",
    "could_not_create_timesheet": "Could not create timesheet",
    "this_timesheet_records_overtime_holiday_sick_training_or_extra_payable": "This timesheet records overtime, holiday, sick, training, or extra payable hours. Fixed salary remains controlled by the employee pay setup.",
    "this_timesheet_records_payable_hours_for_the_selected_payroll_period": "This timesheet records payable hours for the selected payroll period.",
    "create_a_draft_timesheet_for_a_generated_payroll_period": "Create a draft timesheet for a generated payroll period.",
    "choose_employee": "Choose employee",
    "choose_payroll_period": "Choose payroll period",
    "import_support_is_ready_for_csvtimeclock_integrations_this_pass_creates": "Import support is ready for CSV/time-clock integrations. This pass creates draft payroll timesheets only.",
    "approve_payroll": "Approve Payroll",
    "prepare_finance_preview": "Prepare Finance Preview",
    "view_payroll": "View Payroll",
    "open_payroll": "Open Payroll",
    "could_not_load_payroll_runs": "Could not load payroll runs",
    "gross": "Gross",
    "net_preview_2": "Net preview",
    "ready_4": "✓ Ready",
    "create_a_run_from_an_open_payroll_period_to_start": "Create a run from an open payroll period to start the guided payroll review.",
    "not_supplied": "Not supplied",
    "recorded_user": "Recorded user",
    "employeelevel_statutory_values_are_ready_for_payroll_documents_and_future": "Employee-level statutory values are ready for payroll documents and future payslips.",
    "legacy_providersupplied_statutory_values_are_held_at_run_level_and": "Legacy provider-supplied statutory values are held at run level and are not employee payslips.",
    "missing_paye": "Missing PAYE",
    "missing_employee_ni": "Missing Employee NI",
    "missing_employer_ni": "Missing Employer NI",
    "net_pay_below_zero": "Net pay below zero",
    "unsaved_changes_reset": "Unsaved changes reset.",
    "postedlocked_payroll_runs_are_readonly": "Posted/locked payroll runs are read-only.",
    "complete_paye_employee_ni_and_employer_ni_for_every_employee": "Complete PAYE, Employee NI, and Employer NI for every employee before saving.",
    "employee_statutory_payroll_inputs_saved": "Employee statutory payroll inputs saved.",
    "payroll_rows_changed_refreshing_this_run_please_review_and_save": "Payroll rows changed. Refreshing this run — please review and save again.",
    "could_not_save_statutory_payroll_inputs": "Could not save statutory payroll inputs.",
    "paye_income_tax_2": "PAYE Income Tax",
    "employee_national_insurance_2": "Employee National Insurance",
    "employer_national_insurance_2": "Employer National Insurance",
    "employee_pension": "Employee Pension",
    "other_employee_deductions": "Other Employee Deductions",
    "net_pay_2": "Net Pay",
    "total_employer_cost": "Total Employer Cost",
    "invalid": "Invalid",
    "missing_inputs": "Missing inputs",
    "complete_3": "Complete",
    "could_not_create_payroll_run": "Could not create payroll run",
    "create_a_payroll_run_from_a_generated_payroll_period": "Create a payroll run from a generated payroll period.",
    "choose_calendar": "Choose calendar",
    "choose_open_generated_period": "Choose open generated period",
    "resolve_blockers": "Resolve blockers",
    "fix_payroll_blockers_before_submitting": "Fix payroll blockers before submitting.",
    "enter_statutory_payroll_inputs": "Enter statutory payroll inputs",
    "enter_providersupplied_paye_employee_ni_and_employer_ni_for_each": "Enter provider-supplied PAYE, Employee NI, and Employer NI for each employee before approval.",
    "calculate_payroll": "Calculate payroll",
    "approve_payroll_2": "Approve payroll",
    "resolve_blockers_before_approval_2": "Resolve blockers before approval.",
    "prepare_finance_preview_2": "Prepare finance preview",
    "post_payroll_to_accounting": "Post payroll to accounting",
    "journal_not_balanced_review_the_finance_preview_before_posting": "Journal not balanced. Review the finance preview before posting.",
    "record_payroll_payment": "Record Payroll Payment",
    "lock_payroll": "Lock payroll",
    "payroll_complete": "Payroll complete",
    "this_payroll_run_is_complete": "This payroll run is complete.",
    "could_not_load_payroll_run": "Could not load payroll run",
    "enter_statutory_payroll_inputs_before_continuing": "Enter statutory payroll inputs before continuing.",
    "payroll_has_already_been_posted_and_cannot_be_rolled_back": "Payroll has already been posted and cannot be rolled back.",
    "payroll_finance_mappings_need_attention": "Payroll finance mappings need attention.",
    "post_payroll_to_accounting_before_payment": "Post payroll to accounting before payment.",
    "complete_finance_posting_payables_and_staff_payment_before_locking_payroll": "Complete finance posting, payables, and staff payment before locking payroll.",
    "this_payroll_run_is_not_ready_for_that_step": "This payroll run is not ready for that step.",
    "payroll_finance_preview_is_not_balanced_yet": "Payroll finance preview is not balanced yet.",
    "this_payroll_run_is_locked": "This payroll run is locked.",
    "payroll_run_updated": "Payroll run updated.",
    "payroll_summary_reports_generated": "Payroll summary reports generated.",
    "nowork_exception_recorded": "No-work exception recorded.",
    "timesheetnotrequired_acknowledgement_recorded": "Timesheet-not-required acknowledgement recorded.",
    "load_the_payroll_run_before_generating_reports": "Load the payroll run before generating reports.",
    "payroll_run_2": "Payroll Run",
    "follow_the_guided_payroll_lifecycle_from_review_through_accounting_posting": "Follow the guided payroll lifecycle from review through accounting posting, outstanding payables, payment, and lock.",
    "review_this_item_before_moving_payroll_forward": "Review this item before moving payroll forward.",
    "open_payroll_settings_and_fix_finance_mappings": "Open Payroll Settings and fix finance mappings.",
    "open_the_related_employee_timesheet_or_deduction_totals_and_update": "Open the related employee, timesheet, or deduction totals and update the missing information.",
    "confirm_staff_portal_publishing_for_this_payroll_run": "Confirm staff portal publishing for this payroll run.",
    "publish_payslips": "Publish payslips",
    "employee_breakdown_uses_saved_employeelevel_statutory_inputs_ready_for_payslip": "Employee breakdown uses saved employee-level statutory inputs. Ready For Payslip means values are captured; generated payslip documents appear in Payroll Documents.",
    "legacy_runlevel_statutory_values_are_not_employee_payslips_final_payslips": "Legacy run-level statutory values are not employee payslips. Final payslips require employee-level statutory values.",
    "pay_type_2": "Pay type",
    "base_pay": "Base pay",
    "regular_hours_2": "Regular hours",
    "overtime_hours_2": "Overtime hours",
    "overtime_pay": "Overtime pay",
    "deductions": "Deductions",
    "runlevel_only": "Run-level only",
    "included_in_run_summary": "Included in run summary",
    "see_run_totals": "See run totals",
    "no_work_this_period": "No work this period",
    "runlevel_statutory_values": "Run-level statutory values",
    "show": "Show",
    "payable_created": "Payable created",
    "no_payment_preview_yet": "No payment preview yet.",
    "approval": "Approval",
    "payroll_approval_required": "Payroll approval required",
    "finance_admin": "Finance / Admin",
    "no_due_date": "No due date",
    "no_linked_item_is_available_yet": "No linked item is available yet.",
    "open_the_linked_payroll_item": "Open the linked payroll item.",
    "open_linked_item": "Open linked item",
    "no_action_available": "No action available",
    "no_payroll_approvals_or_blocker_reviews_are_waiting": "No payroll approvals or blocker reviews are waiting.",
    "payroll_clearing": "Payroll clearing",
    "benefits_and_other": "Benefits and other",
    "payroll_obligation": "Payroll obligation",
    "create_payment_coming_soon": "Create payment coming soon",
    "preview_only": "Preview only",
    "create_and_calculate_a_payroll_run_to_see_payroll_liability": "Create and calculate a payroll run to see payroll liability previews.",
    "no_rounding": "No rounding",
    "round_to_nearest_5_minutes": "Round to nearest 5 minutes",
    "round_to_nearest_15_minutes": "Round to nearest 15 minutes",
    "round_up_to_nearest_15_minutes": "Round up to nearest 15 minutes",
    "settings_saved": "Settings saved.",
    "unable_to_save_settings": "Unable to save settings.",
    "payroll_policies_saved": "Payroll policies saved.",
    "unable_to_save_payroll_policies": "Unable to save payroll policies.",
    "unable_to_refresh_payroll_rule_defaults": "Unable to refresh payroll rule defaults.",
    "provider_supplied": "Provider Supplied",
    "privana_records_statutory_payroll_outputs_supplied_by_your_accountant_payroll": "Privana records statutory payroll outputs supplied by your accountant, payroll bureau, or payroll software.",
    "connected_payroll_engine": "Connected Payroll Engine",
    "coming_soon_privana_will_receive_statutory_outputs_from_a_connected": "Coming soon — Privana will receive statutory outputs from a connected payroll engine.",
    "checked_manually": "Checked Manually",
    "checked_by_a_person_before_approval": "Checked by a person before approval.",
    "privana_calculates": "Privana Calculates",
    "privana_calculates_this_when_configured": "Privana calculates this when configured.",
    "handled_outside_privana": "Handled Outside Privana",
    "handled_outside_privana_final_totals_are_entered_manually": "Handled outside Privana; final totals are entered manually.",
    "not_used": "Not Used",
    "disabled": "Disabled.",
    "provider_supplied_values_are_entered_during_payroll_run_review": "Provider Supplied — values are entered during payroll run review.",
    "statutory_values_change_every_payroll_run_so_they_are_entered": "Statutory values change every payroll run, so they are entered on the payroll run review screen, not in settings.",
    "employer_pension_contributions": "Employer Pension Contributions",
    "clubfunded_workplace_pension_cost": "Club-funded workplace pension cost.",
    "set_the_employer_pension_rate_privana_should_calculate_from_eligible": "Set the employer pension rate Privana should calculate from eligible gross pay.",
    "fixed_employer_contributions": "Fixed Employer Contributions",
    "flat_employer_contribution_per_run_when_your_club_uses_one": "Flat employer contribution per run when your club uses one.",
    "use_only_for_fixed_club_employer_costs_that_should_be": "Use only for fixed club employer costs that should be added to each payroll run.",
    "manual_employer_cost_adjustments": "Manual Employer Cost Adjustments",
    "auditable_manual_employer_cost_adjustment": "Auditable manual employer cost adjustment.",
    "use_for_reviewed_employer_costs_that_are_not_statutory_deductions": "Use for reviewed employer costs that are not statutory deductions or pension.",
    "workplace_pension_scheme": "Workplace Pension Scheme",
    "provider_employee_contribution_club_contribution_and_autoenrolment_settings": "Provider, employee contribution, club contribution, and auto-enrolment settings.",
    "set_the_provider_and_contribution_percentages_your_club_uses_for": "Set the provider and contribution percentages your club uses for auto-enrolment.",
    "additional_pay_for_approved_overtime_hours": "Additional pay for approved overtime hours.",
    "use_the_multiplier_your_club_applies_when_approved_hours_are": "Use the multiplier your club applies when approved hours are worked beyond normal hours.",
    "holiday_pay": "Holiday Pay",
    "paid_annual_leave": "Paid annual leave.",
    "choose_how_holiday_pay_is_handled_for_your_club_staff": "Choose how holiday pay is handled for your club staff.",
    "sick_pay": "Sick Pay",
    "pay_for_approved_sickness_absence": "Pay for approved sickness absence.",
    "choose_statutory_sick_pay_your_club_policy_or_manual_review": "Choose statutory sick pay, your club policy, or manual review.",
    "private_healthcare_car_allowances_and_other_benefits": "Private healthcare, car allowances and other benefits.",
    "turn_this_on_only_if_your_club_tracks_employee_benefits": "Turn this on only if your club tracks employee benefits in payroll.",
    "statutory_payroll": "Statutory Payroll",
    "pension_benefits": "Pension & Benefits",
    "pay_policies": "Pay Policies",
    "customised": "Customised",
    "using_defaults": "Using Defaults",
    "disabled_2": "Disabled",
    "enabled_2": "Enabled",
    "united_kingdom": "🇬🇧 United Kingdom",
    "united_states": "🇺🇸 United States",
    "european_payroll_region": "🇪🇺 European payroll region",
    "payroll_jurisdiction_not_set": "Payroll jurisdiction not set",
    "united_kingdom_payroll_rules": "United Kingdom Payroll Rules",
    "united_states_payroll_rules": "United States Payroll Rules",
    "european_payroll_rules": "European Payroll Rules",
    "payroll_rules": "Payroll Rules",
    "payroll_calendar_saved": "Payroll calendar saved.",
    "unable_to_save_payroll_calendar": "Unable to save payroll calendar.",
    "payroll_periods_generated_open_generated_periods_were_refreshed_locked_paid": "Payroll periods generated. Open generated periods were refreshed; locked, paid, and closed periods were preserved.",
    "payroll_calendar_updated": "Payroll calendar updated.",
    "payroll_calendar_action_failed": "Payroll calendar action failed.",
    "unable_to_load_payroll_settings": "Unable to load payroll settings.",
    "payroll_calendars_define_how_privana_creates_payroll_periods_approval_deadlines": "Payroll Calendars define how Privana creates payroll periods, approval deadlines, timesheet cut-offs, and pay dates.",
    "cycle_anchor_date": "Cycle anchor date",
    "first_period_anchor_preview_from": "First period anchor / preview from",
    "period_dates": "Period dates",
    "timesheet_cutoff": "Timesheet cutoff",
    "save_calendar": "Save calendar",
    "store_clublevel_policy_defaults_for_future_payroll_calculations": "Store club-level policy defaults for future payroll calculations.",
    "holiday_pay_enabled": "Holiday pay enabled",
    "sick_pay_enabled": "Sick pay enabled",
    "sick_pay_requires_manager_review": "Sick pay requires manager review",
    "save_pay_rules": "Save pay rules",
    "timesheet_rounding_controls_how_clockinout_times_are_normalised_before_payroll": "Timesheet rounding controls how clock-in/out times are normalised before payroll review.",
    "save_timesheet_rules": "Save timesheet rules",
    "plainenglish_club_payroll_choices_privana_keeps_technical_engine_settings_tucked": "Plain-English club payroll choices. Privana keeps technical engine settings tucked away unless support needs them.",
    "confirm_pension_scheme_defaults_and_staff_benefits_your_club_tracks": "Confirm pension scheme defaults and staff benefits your club tracks.",
    "set_how_your_club_handles_overtime_holiday_pay_and_sickness": "Set how your club handles overtime, holiday pay and sickness absence.",
    "coming_soon_privana_does_not_currently_connect_to_payroll_engines": " (Coming soon. Privana does not currently connect to payroll engines for statutory calculations.)",
    "benefits_enabled": "Benefits enabled",
    "included_in_salary": "Included in Salary",
    "timesheet_based": "Timesheet Based",
    "statutory_sick_pay": "Statutory Sick Pay",
    "club_policy": "Club Policy",
    "these_controls_determine_which_payroll_checks_privana_assist_will_surface": "These controls determine which payroll checks Privana Assist will surface during payroll review.",
    "variance_alerts": "Variance alerts",
    "missing_data_checks": "Missing data checks",
    "duplicate_payment_detection": "Duplicate payment detection",
    "payroll_readiness_summary": "Payroll readiness summary",
    "save_privana_assist_controls": "Save Privana Assist controls",
    "production_role_model_for_payroll_access": "Production role model for payroll access.",
    "payroll_admin": "Payroll Admin",
    "manage_payroll_settings": "Manage payroll settings",
    "create_payroll_runs": "Create payroll runs",
    "edit_employees": "Edit employees",
    "payroll_approver": "Payroll Approver",
    "approve_payroll_runs": "Approve payroll runs",
    "approve_payroll_liabilities": "Approve payroll liabilities",
    "view_journal_previews": "View journal previews",
    "department_manager": "Department Manager",
    "approve_timesheets": "Approve timesheets",
    "review_overtime": "Review overtime",
    "view_department_payroll_summaries": "View department payroll summaries",
    "read_only_2": "Read Only",
    "view_payroll_dashboard": "View payroll dashboard",
    "view_payroll_reports": "View payroll reports",
    "no_editing_rights": "No editing rights",
    "needs_finance": "Needs finance",
    "verified": "Verified",
    "high": "High",
    "medium": "Medium",
    "ap_payment_recorded": "AP payment recorded.",
    "12month_gross_payroll_with_monthly_variance": "12-month gross payroll with monthly variance.",
    "a_department_with_this_name_already_exists": "A department with this name already exists.",
    "supplier_bill": "Supplier Bill",
    "part_paid": "Part Paid",
    "ready_for_payment": "Ready for Payment",
    "club_context_is_missing_select_a_club_to_view_payables": "Club context is missing. Select a club to view payables.",
    "unable_to_load_accounts_payable_data": "Unable to load accounts payable data.",
    "source_navigation_unavailable_for_this_payable": "Source navigation unavailable for this payable.",
    "add_at_least_one_bill_line_before_posting": "Add at least one bill line before posting.",
    "unable_to_post_bill": "Unable to post bill.",
    "unable_to_void_bill": "Unable to void bill.",
    "allocations_unapplied": "Allocations unapplied.",
    "unable_to_unapply_allocations": "Unable to unapply allocations.",
    "allocations_reallocated": "Allocations reallocated.",
    "unable_to_reallocate_payment": "Unable to reallocate payment.",
    "enter_a_valid_refund_amount": "Enter a valid refund amount.",
    "refund_exceeds_available_amount": "Refund exceeds available amount.",
    "select_a_bank_account_for_bank_refunds": "Select a bank account for bank refunds.",
    "refund_recorded": "Refund recorded.",
    "configure_ap_control_and_payment_accounts_before_refunding": "Configure AP control and payment accounts before refunding.",
    "unable_to_refund_payment": "Unable to refund payment.",
    "total_payables": "Total Payables",
    "outstanding_payables": "Outstanding Payables",
    "due_this_month": "Due This Month",
    "supplier_payables": "Supplier Payables",
    "payroll_liabilities_2": "Payroll Liabilities",
    "accounts_payable": "Accounts Payable",
    "posting": "Posting...",
    "enter": "Enter",
    "missing_information": "Missing information",
    "please_complete_all_required_fields_before_saving": "Please complete all required fields before saving.",
    "bank_account_added": "Bank account added",
    "the_bank_account_is_ready_for_reconciliation": "The bank account is ready for reconciliation.",
    "failed_to_add_bank_account": "Failed to add bank account",
    "please_try_again_or_contact_support": "Please try again or contact support.",
    "loading_gl_accounts": "Loading GL accounts...",
    "save_bank_account": "Save bank account",
    "failed_to_load_bank_accounts": "Failed to load bank accounts",
    "bank_account_updated": "Bank account updated",
    "failed_to_update_bank_account": "Failed to update bank account",
    "default_account_updated": "Default account updated",
    "this_bank_account_is_now_the_default": "This bank account is now the default.",
    "failed_to_update_default": "Failed to update default",
    "no_gl_accounts": "No GL accounts",
    "update_failed": "Update failed",
    "unable_to_update_review_status": "Unable to update review status.",
    "marked_reviewed": "Marked reviewed",
    "marked_unreviewed": "Marked unreviewed",
    "unable_to_update_review_status_for_selected_transactions": "Unable to update review status for selected transactions.",
    "missing_reconciliation_scope": "Missing reconciliation scope",
    "refresh_summary_to_load_statement_scope_before_finalizing": "Refresh summary to load statement scope before finalizing.",
    "reconciliation_finalized": "Reconciliation finalized",
    "this_account_period_is_now_marked_complete": "This account period is now marked complete.",
    "unable_to_finalize": "Unable to finalize",
    "resolve_all_unmatched_queues_before_finalizing": "Resolve all unmatched queues before finalizing.",
    "ready_to_finalize": "Ready to finalize",
    "mark_unreviewed_2": "Mark Unreviewed",
    "mark_reviewed_2": "Mark Reviewed",
    "no_transactions_yet_upload_a_statement_to_get_started": "No transactions yet. Upload a statement to get started.",
    "select_a_bank_account_to_view_transactions": "Select a bank account to view transactions.",
    "no_bank_accounts_yet_use_the_settings_menu_to_add": "No bank accounts yet. Use the settings menu to add a bank account.",
    "autodetect": "Auto-detect",
    "date_column_is_required": "Date column is required.",
    "description_column_is_required": "Description column is required.",
    "provide_either_an_amount_column_or_a_debitcredit_column": "Provide either an Amount column or a Debit/Credit column.",
    "statement_imported": "Statement imported",
    "unable_to_import_statement": "Unable to import statement.",
    "back": "Back",
    "importing": "Importing...",
    "remaining": "Remaining",
    "income": "Income",
    "income_ytd": "Income (YTD)",
    "expenses_ytd": "Expenses (YTD)",
    "unable_to_load_chart_of_accounts": "Unable to load chart of accounts.",
    "account_code_and_name_are_required": "Account code and name are required.",
    "unable_to_save_account_changes": "Unable to save account changes.",
    "unable_to_update_account_status": "Unable to update account status.",
    "edit_account": "Edit Account",
    "unable_to_load_dimensions": "Unable to load dimensions.",
    "dimension_code_and_name_are_required": "Dimension code and name are required.",
    "that_dimension_code_already_exists_choose_a_unique_code": "That dimension code already exists. Choose a unique code.",
    "unable_to_save_dimension_changes": "Unable to save dimension changes.",
    "unable_to_update_dimension_status": "Unable to update dimension status.",
    "edit_dimension": "Edit Dimension",
    "operating": "Operating",
    "capex": "CapEx",
    "this_fiscal_year": "This Fiscal Year",
    "custom_range": "Custom range",
    "unable_to_load_reports": "Unable to load reports",
    "missing_fields": "Missing fields",
    "please_enter_a_report_name_and_type": "Please enter a report name and type.",
    "budget_required": "Budget required",
    "select_a_budget_to_run_budget_vs_actual": "Select a budget to run Budget vs Actual.",
    "budget_version_required": "Budget version required",
    "select_a_budget_version_to_run_budget_vs_actual": "Select a budget version to run Budget vs Actual.",
    "unable_to_save_report": "Unable to save report",
    "are_you_sure_you_want_to_delete_this_report": "Are you sure you want to delete this report?",
    "unable_to_delete_report": "Unable to delete report",
    "gl_account_code": "GL Account Code",
    "gl_account_name": "GL Account Name",
    "ytd_budget": "YTD Budget",
    "ytd_actual": "YTD Actual",
    "ytd_variance": "YTD Variance",
    "ytd_variance_2": "YTD Variance %",
    "pdf_export_not_available_yet_use_csv": "PDF export not available yet. Use CSV.",
    "xlsx_export_coming_soon_for_budget_vs_actual": "XLSX export coming soon for Budget vs Actual",
    "unable_to_download_report": "Unable to download report",
    "unable_to_run_report": "Unable to run report",
    "ondemand": "On-demand",
    "failed_to_load_matches": "Failed to load matches",
    "unable_to_load_matching_candidates_please_try_again": "Unable to load matching candidates. Please try again.",
    "no_remaining_balance": "No remaining balance",
    "reduce_another_match_amount_before_selecting_this_allocation": "Reduce another match amount before selecting this allocation.",
    "match_saved": "Match saved",
    "bank_transaction_matching_updated": "Bank transaction matching updated.",
    "failed_to_save_match": "Failed to save match",
    "unable_to_update_bank_transaction_match_items": "Unable to update bank transaction match items.",
    "match_cleared": "Match cleared",
    "match_items_removed_for_this_transaction": "Match items removed for this transaction.",
    "failed_to_clear_match": "Failed to clear match",
    "unable_to_clear_match_items_for_this_transaction": "Unable to clear match items for this transaction.",
    "bank_transaction": "Bank transaction",
    "unknown_period": "Unknown Period",
    "trial_balance_snapshot": "Trial Balance Snapshot",
    "snapshot": "Snapshot",
    "unknown": "Unknown",
    "unassigned_account": "Unassigned account",
    "unable_to_update_task": "Unable to update task",
    "notes_saved": "Notes saved",
    "unable_to_save_notes": "Unable to save notes",
    "period_closed": "Period closed",
    "close_blocked_by_earlier_periods": "Close blocked by earlier periods",
    "close_failed": "Close failed",
    "unable_to_close_the_period_please_try_again": "Unable to close the period. Please try again.",
    "period_locked": "Period locked",
    "complete_required_tasks_or_add_an_override_reason": "Complete required tasks or add an override reason.",
    "lock_failed": "Lock failed",
    "unable_to_lock_the_period_please_try_again": "Unable to lock the period. Please try again.",
    "period_unlocked": "Period unlocked",
    "unlock_failed": "Unlock failed",
    "unable_to_unlock_the_period_please_try_again": "Unable to unlock the period. Please try again.",
    "period_reopened": "Period reopened",
    "reopen_failed": "Reopen failed",
    "unable_to_reopen_the_period_please_try_again": "Unable to reopen the period. Please try again.",
    "snapshot_queued": "Snapshot queued",
    "close_pack_snapshot_is_running": "Close pack snapshot is running.",
    "snapshot_failed": "Snapshot failed",
    "optional_tasks": "Optional tasks",
    "no_updates_yet": "No updates yet",
    "lock_month": "Lock Month",
    "unlock_period": "Unlock Period",
    "reopen_period": "Reopen Period",
    "run_snapshot": "Run Snapshot",
    "balanced": "Balanced",
    "out_of_balance": "Out of balance",
    "periods_generated": "Periods generated",
    "unable_to_generate_periods": "Unable to generate periods.",
    "unable_to_generate_periods_2": "Unable to generate periods",
    "unable_to_load_snapshot": "Unable to load snapshot",
    "current_period_is_locked_unlock_to_continue_closing": "Current period is locked. Unlock to continue closing.",
    "loading_years": "Loading years...",
    "generate_periods_for_selected_year": "Generate periods for selected year",
    "unable_to_load_periods": "Unable to load periods",
    "please_refresh_to_try_again": "Please refresh to try again.",
    "created": "Created",
    "edit_invoice": "Edit Invoice",
    "failed_to_load_layout_settings": "Failed to load layout settings.",
    "billing_email_must_be_blank_or_a_valid_email_address": "Billing email must be blank or a valid email address.",
    "accent_color_must_be_a_valid_hex_color": "Accent color must be a valid HEX color.",
    "footer_note_must_be_1000_characters_or_fewer": "Footer note must be 1000 characters or fewer.",
    "layout_saved_successfully": "Layout saved successfully!",
    "failed_to_save_layout": "Failed to save layout.",
    "save_layout": "Save Layout",
    "received": "Received",
    "paid_via_direct_payment_2": "Paid via Direct Payment",
    "included_in_billing_run": "Included in Billing Run",
    "fully_applied": "Fully applied",
    "partially_applied": "Partially applied",
    "enter_allocation_amounts": "Enter allocation amounts.",
    "allocations_exceed_available_credit": "Allocations exceed available credit.",
    "credit_allocated": "Credit allocated.",
    "unable_to_allocate_credit": "Unable to allocate credit.",
    "credit_refund_recorded": "Credit refund recorded.",
    "refund_payment_recorded": "Refund payment recorded.",
    "configure_ar_control_and_payment_accounts_before_refunding": "Configure AR control and payment accounts before refunding.",
    "credit_refund_not_allowed": "Credit refund not allowed.",
    "refund_not_allowed": "Refund not allowed.",
    "cannot_refund_a_refund_payment": "Cannot refund a refund payment.",
    "unable_to_record_refund": "Unable to record refund.",
    "source_navigation_unavailable": "Source navigation unavailable",
    "enter_a_valid_credit_amount": "Enter a valid credit amount.",
    "credit_applied": "Credit applied.",
    "unable_to_apply_credit": "Unable to apply credit.",
    "credit_note": "Credit Note",
    "on_account": "On Account",
    "allocated_payment": "Allocated payment",
    "linked_pos_sale": "Linked POS sale",
    "see_pos_transaction_detail": "See POS transaction detail",
    "unapplying": "Unapplying...",
    "unapply": "Unapply",
    "open_originating_source": "Open originating source",
    "source_resolution_unavailable": "Source resolution unavailable",
    "view_statement": "View Statement",
    "reallocate_payment": "Reallocate Payment",
    "refund_credit_2": "Refund credit",
    "submit_refund_payment": "Submit refund payment",
    "no_available_credit_to_apply": "No available credit to apply",
    "no_open_invoices_to_apply_credit_to": "No open invoices to apply credit to",
    "apply_available_member_credit": "Apply available member credit",
    "unable_to_load_current_period": "Unable to load current period",
    "unable_to_load_close_checklist": "Unable to load close checklist",
    "unable_to_close_period": "Unable to close period.",
    "unable_to_close_period_2": "Unable to close period",
    "unable_to_lock_period": "Unable to lock period.",
    "unable_to_lock_period_2": "Unable to lock period",
    "unable_to_unlock_period": "Unable to unlock period",
    "unable_to_reopen_period": "Unable to reopen period",
    "select_period": "Select period",
    "complete_required_tasks_or_provide_an_override_reason": "Complete required tasks or provide an override reason.",
    "required_tasks_must_be_completed_override_not_permitted": "Required tasks must be completed (override not permitted).",
    "close_period": "Close Period",
    "lock_period": "Lock Period",
    "adjusting": "Adjusting",
    "reversal": "Reversal",
    "year_end": "Year End",
    "accrual": "Accrual",
    "member_accounts_receivable": "Member Accounts Receivable",
    "billing_recurring_billing": "Billing / Recurring Billing",
    "staff_selected": "Staff selected",
    "you_dont_have_permission_to_perform_this_action": "You don't have permission to perform this action.",
    "endpoint_not_deployed_route_missing": "Endpoint not deployed / route missing.",
    "server_error_check_logs": "Server error — check logs.",
    "failed_to_load_monthend_tasks": "Failed to load month-end tasks",
    "unable_to_load_tasks": "Unable to load tasks",
    "failed_to_load_monthend_exceptions": "Failed to load month-end exceptions",
    "unable_to_load_exceptions": "Unable to load exceptions",
    "delete_this_task_template": "Delete this task template?",
    "delete_this_exception_policy": "Delete this exception policy?",
    "task_name_is_required": "Task name is required",
    "task_templates_saved": "Task templates saved",
    "failed_to_save_task_templates": "Failed to save task templates",
    "unable_to_save_task_templates": "Unable to save task templates",
    "reason_is_required_for_exceptions": "Reason is required for exceptions",
    "exception_policies_saved": "Exception policies saved",
    "failed_to_save_exception_policies": "Failed to save exception policies",
    "unable_to_save_exception_policies": "Unable to save exception policies",
    "walkin": "Walk-in",
    "unposted": "Unposted",
    "review_post": "Review & Post",
    "voided": "Voided",
    "fix_repost": "Fix & Repost",
    "view_issue": "View Issue",
    "this_receivable_is_sourcemanaged_and_must_be_corrected_from_its": "This receivable is source-managed and must be corrected from its originating workflow or posting process.",
    "guest": "Guest",
    "adhoc": "Ad-hoc",
    "unable_to_resolve_this_golf_booking_source": "Unable to resolve this Golf booking source.",
    "unable_to_resolve_this_racquet_booking_source": "Unable to resolve this Racquet booking source.",
    "unable_to_resolve_this_spa_booking_source": "Unable to resolve this Spa booking source.",
    "unable_to_resolve_this_fitness_booking_source": "Unable to resolve this Fitness booking source.",
    "unable_to_resolve_this_event_source": "Unable to resolve this event source.",
    "unable_to_resolve_this_room_reservation_source": "Unable to resolve this room reservation source.",
    "source_navigation_is_not_available_for_this_charge_yet": "Source navigation is not available for this charge yet.",
    "this_receivable_is_sourcemanaged_and_cannot_be_manually_posted_here": "This receivable is source-managed and cannot be manually posted here.",
    "unable_to_post_receivable": "Unable to post receivable.",
    "unable_to_create_credit_note": "Unable to create credit note.",
    "debtor_type": "Debtor Type",
    "billing_run_2": "Billing / Run",
    "open_invoice_detail": "Open invoice detail",
    "invoice_not_yet_generated": "Invoice not yet generated",
    "void_allocation": "Void allocation",
    "choose_open_member_invoice": "Choose open member invoice…",
    "save_draft_post_credit_note": "Save Draft / Post Credit Note",
    "unable_to_enroll_member": "Unable to enroll member",
    "golf_green_fees": "Golf green fees",
    "golf_addons_caddie_hire": "Golf add-ons / caddie hire",
    "unmapped_charge": "Unmapped charge",
    "member_account": "Member Account",
    "will_be_generated_during_next_billing_run": "Will be generated during next billing run",
    "deferred_from_earlier_billing": "Deferred from earlier billing",
    "move_back_to_this_statement": "Move back to this statement",
    "next_billing_run": "Next billing run",
    "future_billing_run": "Future billing run",
    "no_billable_items_are_currently_available_for_invoicing": "No billable items are currently available for invoicing.",
    "unable_to_preview_invoice": "Unable to preview invoice",
    "download_failed": "Download failed",
    "unable_to_generate_and_download_invoice": "Unable to generate and download invoice",
    "unable_to_generate_and_send_invoice": "Unable to generate and send invoice",
    "invoice_generated_successfully_but_the_email_could_not_be_delivered": "Invoice generated successfully, but the email could not be delivered.",
    "the_invoice_is_available_in_invoicing": "The invoice is available in Invoicing.",
    "invoice_generated_and_emailed_successfully": "Invoice generated and emailed successfully.",
    "unable_to_generate_club_run": "Unable to generate club run",
    "choose_a_valid_current_or_future_billing_run": "Choose a valid current or future billing run.",
    "billing_run_updated": "Billing run updated.",
    "unable_to_update_billing_run": "Unable to update billing run",
    "unable_to_update_charge": "Unable to update charge",
    "unable_to_load_dues_enrollments": "Unable to load dues enrollments",
    "billing_run_generated": "Billing run generated.",
    "unable_to_generate_recurring_billing_run": "Unable to generate recurring billing run",
    "unable_to_run_bulk_action": "Unable to run bulk action",
    "recurring_billing_cannot_be_activated_until_a_dues_amount_greater_2": "Recurring billing cannot be activated until a dues amount greater than zero is entered.",
    "choose_a_monthly_quarterly_or_annual_frequency_before_enrolling_this": "Choose a monthly, quarterly, or annual frequency before enrolling this member.",
    "unable_to_generate_invoice": "Unable to generate invoice",
    "unable_to_load_statement_preview_please_try_again": "Unable to load statement preview. Please try again.",
    "unable_to_record_payments": "Unable to record payments",
    "unable_to_save_settings_2": "Unable to save settings",
    "current_period_2": "Current period",
    "sending_2": "Sending...",
    "generate_send": "Generate & Send",
    "generate_club_run": "Generate Club Run",
    "current_run": "Current Run",
    "resolve_gl_mapping_warnings_before_generating_this_run": "Resolve GL mapping warnings before generating this run.",
    "membership_dues": "Membership dues",
    "draft_invoice": "Draft invoice",
    "line_item": "Line item",
    "confirm_generate": "Confirm Generate",
    "generate_download": "Generate & Download",
    "primary_charge": "Primary Charge",
    "save_billing_run": "Save Billing Run",
    "chart_of_accounts_verified": "Chart of Accounts verified",
    "tax_codes_verified": "Tax codes verified",
    "dimensions_verified": "Dimensions verified",
    "revenue_mappings_verified": "Revenue mappings verified",
    "payroll_mappings_verified": "Payroll mappings verified",
    "label_is_required": "Label is required.",
    "label_must_include_letters_or_numbers": "Label must include letters or numbers.",
    "that_label_creates_a_duplicate_key_try_a_slightly_different": "That label creates a duplicate key. Try a slightly different label.",
    "unable_to_save_the_revenue_mapping": "Unable to save the revenue mapping.",
    "unable_to_save_the_payroll_mapping": "Unable to save the payroll mapping.",
    "unable_to_apply_regional_accounting_defaults": "Unable to apply regional accounting defaults.",
    "accounting_defaults_refreshed": "Accounting defaults refreshed.",
    "payroll_defaults_refreshed": "Payroll defaults refreshed.",
    "historical": "Historical",
    "final_checks_are_taking_a_moment": "Final checks are taking a moment…",
    "finalising_accounting_defaults_and_mappings": "Finalising accounting defaults and mappings…",
    "edit_gl_mapping": "Edit GL Mapping",
    "new_gl_mapping": "New GL Mapping",
    "unable_to_load_yearend_assistant": "Unable to load Year-End Assistant",
    "unable_to_load_fiscal_years_right_now_please_refresh_and": "Unable to load fiscal years right now. Please refresh and try again.",
    "yearend_is_blocked": "Year-end is blocked",
    "resolve_all_blocker_checks_before_closing_this_fiscal_year": "Resolve all blocker checks before closing this fiscal year.",
    "unable_to_close_fiscal_year": "Unable to close fiscal year",
    "please_review_blockers_and_try_again": "Please review blockers and try again.",
    "billing_period": "Billing period",
    "not_billable": "Not billable",
    "recurring": "Recurring",
    "recurring_billing_run": "Recurring billing run",
    "direct_payment": "Direct payment",
    "not_billable_voidedcancelled": "Not billable: voided/cancelled",
    "need_to_collect": "Need to Collect",
    "blocked_missing_revenue_mapping": "Blocked: missing revenue mapping",
    "manual_invoice": "Manual Invoice",
    "recurring_run": "Recurring run",
    "payroll_method_2": "Payroll method:",
    "impact": "Impact:",
    "period_2": "Period:",
    "timesheet_cutoff_2": "Timesheet cutoff:",
    "approval_deadline_2": "Approval deadline:",
    "pay_date_2": "Pay date:",
    "employee_2": "Employee:",
    "method_2": "Method:",
    "receivable": "Receivable:",
    "payment_2": "Payment:",
    "allocations": "Allocations:",
    "gl_journal": "GL Journal:",
    "pos_sale_2": "POS Sale:",
    "taxvat": "Tax/VAT:",
    "inventory_movement": "Inventory Movement:",
    "credit_note_2": "Credit note #:",
    "amount_2": "Amount:",
    "invoice_3": "Invoice:",
    "posted_2": "Posted:",
    "posted_at": "Posted at:",
    "created_by": "Created by:",
    "source_ref": "Source Ref:",
    "gl_mapping_2": "GL Mapping:",
    "payment_source": "Payment Source:",
    "payment_reference": "Payment Reference:",
    "issued_due": "Issued / Due:",
    "revenue_gl_account": "Revenue GL Account:",
    "receivables_control": "Receivables Control:",
    "cashbankcard_clearing": "Cash/Bank/Card Clearing:",
    "tax_code_3": "Tax Code:",
    "tax_rate_2": "Tax Rate:",
    "vattax_amount": "VAT/Tax Amount:",
    "vat_payable_gl": "VAT Payable GL:",
    "dimension_2": "Dimension:",
    "allocation_status": "Allocation Status:",
    "created_posted": "Created / Posted:",
    "gl_journalbatch": "GL Journal/Batch:",
    "pos_payment": "POS Payment:",
    "voidrefundreversal": "Void/Refund/Reversal:",
    "skipped_items": "Skipped Items:",
    "warnings": "Warnings:",
    "panel": "Panel",
    "balance_due_value0": "Balance due: {value0}",
    "value0_avatar": "{value0} avatar",
    "value0_employees_value1": "{value0} employees • {value1}%",
    "move_this_payroll_run_back_to_value0": "Move this payroll run back to {value0}",
    "step_value0": "Step {value0}",
    "value0_stage_value1_pay_date_value2": "{value0} stage • {value1} • Pay date: {value2}",
    "affected_value0": "Affected: {value0}",
    "recommended_fix_value0": "Recommended fix: {value0}",
    "move_value0_department": "Move {value0} department",
    "warning_value0_active_current_rates_overlap_payroll_runs_use_the": "Warning: {value0} active current rates overlap. Payroll runs use the most recent effective rate; saving a new active rate will close older overlaps.",
    "user_value0": "User: {value0}",
    "record_payroll_wage_expense_for_value0": "Record payroll wage expense for {value0}",
    "create_payroll_clearing_liability_for_net_staff_payments_of_value0": "Create payroll clearing liability for net staff payments of {value0}",
    "paye_income_tax_value0": "PAYE Income Tax: {value0}",
    "employee_national_insurance_value0": "Employee National Insurance: {value0}",
    "employer_national_insurance_value0": "Employer National Insurance: {value0}",
    "hmrc_total_value0": "HMRC total: {value0}",
    "privana_assist_value0": "Privana Assist: {value0}",
    "value0_adjustment_rows_available": "{value0} adjustment rows available.",
    "value0_pay_date_value1": "{value0} • Pay date: {value1}",
    "value0_of_value1_employees_complete": "{value0} of {value1} employees complete",
    "value0_pay_value1": "{value0} • Pay {value1}",
    "journal_count_value0": "Journal count: {value0}",
    "primary_journal_value0": "Primary journal: {value0}",
    "duplicates_value0": "Duplicates: {value0}",
    "value0_new_eligible_employee_is_not_included_yet_recalculate_payroll": "{value0} new eligible employee is not included yet. Recalculate payroll to include them.",
    "fix_action_value0": "Fix action: {value0}",
    "owner_value0_due_value1": "Owner: {value0} • Due: {value1}",
    "due_value0_source_value1": "Due: {value0} • Source: {value1}",
    "value0_detected_automatically_from_your_club_address": "{value0} detected automatically from your club address.",
    "last_refreshed_value0": "Last refreshed: {value0}",
    "value0_enabled": "{value0} enabled",
    "minimum_earnings_threshold_value0": "Minimum Earnings Threshold ({value0})",
    "remaining_capacity_value0": "Remaining capacity: {value0}",
    "amount_must_be_between_0_and_value0": "Amount must be between 0 and {value0}.",
    "finalized_value0_by_value1": "Finalized {value0} by {value1}.",
    "value0_selected": "{value0} selected",
    "select_transaction_value0": "Select transaction {value0}",
    "ref_value0": "Ref: {value0}",
    "detected_format_value0": "Detected format: {value0}",
    "value0_more": " (+{value0} more)",
    "previewing_value0_of_value1_rows": "Previewing {value0} of {value1} rows.",
    "step_value0_of_4": "Step {value0} of 4",
    "actual_value0": "Actual: {value0}",
    "budget_value0": "Budget: {value0}",
    "difference_value0": "Difference: {value0}",
    "version_vvalue0": "Version v{value0}",
    "value0_value1_to_value2": "{value0} · {value1} to {value2}",
    "value0_rows": "{value0} rows",
    "as_of_value0": "As of {value0}",
    "confidence_value0": "Confidence {value0}%",
    "status_value0": "Status: {value0}",
    "remaining_to_match_value0": "Remaining to match: {value0}",
    "required_tasks_value0value1_complete": "Required tasks {value0}/{value1} complete.",
    "optional_value0value1": "Optional {value0}/{value1}",
    "updated_value0_by_value1": "Updated {value0} by {value1}",
    "staff_value0": "Staff {value0}",
    "reason_value0": "Reason: {value0}",
    "by_value0": "By {value0}",
    "close_value0_first": "Close {value0} first.",
    "manage_value0": "Manage {value0}",
    "generated_value0_value1": "Generated {value0} {value1}",
    "fyvalue0": "FY{value0}",
    "fiscal_month_value0": "Fiscal Month {value0}",
    "value0value1_required": "{value0}/{value1} required",
    "value0value1_optional": "{value0}/{value1} optional",
    "sort_by_value0": "Sort by {value0}",
    "invoice_value0": "Invoice #{value0}",
    "value0_logo": "{value0} logo",
    "tax_amount_value0_at_value1": "Tax amount {value0} at {value1}.",
    "missing_output_vat_gl_account_used_by_value0_invoice_value1": "Missing Output VAT GL Account — used by {value0} invoice {value1}.",
    "lines_value0": "Lines: {value0}",
    "direct_payment_via_member_portalvalue0": "Direct Payment via Member Portal{value0}",
    "account_details_value0": "Account Details: {value0}",
    "unapplied_credit_available_value0": "Unapplied credit available: {value0}",
    "unapply_credit_value0_value1": "Unapply Credit {value0} ({value1})",
    "max_refundable_value0": "Max refundable: {value0}",
    "account_value0": "Account: {value0}",
    "applied_value0": "Applied: {value0}",
    "value0_date_value1_due_value2": "#{value0} · Date {value1} · Due {value2}",
    "showing_value0value1_of_value2": "Showing {value0}–{value1} of {value2}",
    "value0_value1_payment_value2": "{value0} · {value1} · payment {value2}",
    "value0_value1_vat_value2_gross_value3": "{value0} · {value1} · VAT {value2} · Gross {value3}",
    "value0_value1_dr_value2_cr_value3": "{value0} · {value1} · Dr {value2} · Cr {value3}",
    "generate_issued_invoices_for_value0_selected_members_with_active_recurring": "Generate issued invoices for {value0} selected members with active recurring templates? This will not post to the GL.",
    "will_bill_value0_mapped_items": "Will bill: {value0} mapped item(s).",
    "will_skip_value0_unmapped_items": "Will skip: {value0} unmapped item(s).",
    "key_value0": "(key: {value0})",
    "club_run_complete_value0_generated_value1_failed": "Club run complete: {value0} generated, {value1} failed.",
    "of_value0_members": "of {value0} members",
    "period_value0_outstanding_value1": "Period: {value0} · Outstanding: {value1}",
    "value0_lines": "{value0} lines",
    "value0_value1_lines": "{value0} · {value1} lines",
    "statement_preview_value0": "Statement Preview: {value0}",
    "projected_for_value0": "Projected for {value0}",
    "outstanding_value0": "Outstanding {value0}",
    "value0_scheduled": "{value0} scheduled",
    "billing_period_value0value1": "Billing period: {value0}{value1}",
    "total_billed_value0": "Total billed: {value0}",
    "paid_value0": "Paid: {value0}",
    "outstanding_value0_2": "Outstanding: {value0}",
    "invoices_value0": "Invoices: {value0}",
    "this_will_create_payments_for_open_invoices_totalling_value0": "This will create payments for open invoices totalling {value0}.",
    "sale_value0": "Sale {value0}",
    "membership_type_value0": "Membership type: {value0}. ",
    "key_value0_2": "Key: {value0}",
    "count_value0": "Count: {value0}",
    "blockers_value0": "Blockers: {value0}",
    "warnings_value0": "Warnings: {value0}",
    "passed_value0": "Passed: {value0}",
    "confidence_value0_2": "Confidence: {value0}",
    "value0_passed_checks": "{value0} passed checks",
    "value0_skipped_checks": "{value0} skipped checks",
    "close_fyvalue0": "Close FY{value0}?",
    "receivables": "Receivables",
    "all_fiscal_periods_are_locked": "All fiscal periods are locked",
    "all_accounting_periods_in_the_fiscal_year_must_be_locked": "All accounting periods in the fiscal year must be locked before year-end close.",
    "period_control": "Period Control",
    "no_draft_invoices": "No draft invoices",
    "draft_or_unposted_invoices_in_the_fiscal_year_must_be": "Draft or unposted invoices in the fiscal year must be posted or voided.",
    "transaction_completeness": "Transaction Completeness",
    "no_draft_ap_bills": "No draft AP bills",
    "draft_ap_bills_in_the_fiscal_year_must_be_posted": "Draft AP bills in the fiscal year must be posted or voided.",
    "no_draft_journals": "No draft journals",
    "journal_entries_in_draftunposted_status_must_be_posted_before_yearend": "Journal entries in draft/unposted status must be posted before year-end close.",
    "journals_are_balanced": "Journals are balanced",
    "total_debits_and_credits_must_match_for_each_journal_entry": "Total debits and credits must match for each journal entry in the fiscal year.",
    "control_accounts_configured": "Control accounts configured",
    "required_controldefault_accounts_in_accounting_settings_must_be_configured": "Required control/default accounts in Accounting Settings must be configured.",
    "configuration": "Configuration",
    "applicable_revenue_mappings_configured": "Applicable revenue mappings configured",
    "applicable_active_revenue_mappings_must_have_required_gl_accounts": "Applicable active revenue mappings must have required GL accounts.",
    "bank_reconciliations_complete": "Bank reconciliations complete",
    "active_bank_accounts_should_be_reconciled_through_fiscal_year_end": "Active bank accounts should be reconciled through fiscal year end.",
    "banking_cash": "Banking & Cash",
    "receivables_reviewed": "Receivables reviewed",
    "open_receivables_overdue_as_of_fiscal_year_end_should_be": "Open receivables overdue as of fiscal year end should be reviewed.",
    "review_items": "Review Items",
    "ap_aging_reviewed": "AP aging reviewed",
    "overdue_ap_bills_as_of_fiscal_year_end_should_be": "Overdue AP bills as of fiscal year end should be reviewed.",
    "unapplied_payments_reviewed": "Unapplied payments reviewed",
    "member_payments_with_unapplied_amounts_should_be_reviewed": "Member payments with unapplied amounts should be reviewed.",
    "clearing_accounts_reviewed": "Clearing accounts reviewed",
    "clearing_account_balances_should_be_zeroed_at_fiscal_year_end": "Clearing account balances should be zeroed at fiscal year end.",
    "club_operations": "Club Operations",
    "not_applicable_for_this_clubmodule_configuration": "Not applicable for this club/module configuration.",
    "all_fiscal_year_periods_must_be_locked": "All fiscal year periods must be locked.",
    "review_periods": "Review periods",
    "all_fiscal_year_periods_are_locked": "All fiscal year periods are locked.",
    "no_draft_or_unposted_invoices_remain": "No draft or unposted invoices remain.",
    "no_draft_or_unposted_ap_bills_remain": "No draft or unposted AP bills remain.",
    "review_ap": "Review AP",
    "no_draft_or_unposted_journals_remain": "No draft or unposted journals remain.",
    "review_gl": "Review GL",
    "journals_tables_are_unavailable_in_this_environment": "Journals tables are unavailable in this environment.",
    "value0_journal_entries_are_unbalanced": "{value0} journal entries are unbalanced.",
    "all_journals_are_balanced": "All journals are balanced.",
    "accounting_settings_table_unavailable": "Accounting settings table unavailable.",
    "missing_control_account_mappings_value0": "Missing control account mappings: {value0}.",
    "accounting_settings_2": "Accounting settings",
    "required_control_accounts_are_configured": "Required control accounts are configured.",
    "value0_applicable_revenue_mappings_are_missing_gl_accounts": "{value0} applicable revenue mappings are missing GL accounts.",
    "revenue_mappings_2": "Revenue mappings",
    "applicable_revenue_mappings_are_configured": "Applicable revenue mappings are configured.",
    "bank_reconciliation_readiness_source_is_not_implemented_yet": "Bank reconciliation readiness source is not implemented yet.",
    "invoices_table_unavailable": "Invoices table unavailable.",
    "value0_receivables_are_overdue_as_of_fiscal_year_end": "{value0} receivables are overdue as of fiscal year end.",
    "no_overdue_receivables_as_of_fiscal_year_end": "No overdue receivables as of fiscal year end.",
    "ap_bills_table_unavailable": "AP bills table unavailable.",
    "value0_ap_bills_are_overdue_as_of_fiscal_year_end": "{value0} AP bills are overdue as of fiscal year end.",
    "no_overdue_ap_bills_as_of_fiscal_year_end": "No overdue AP bills as of fiscal year end.",
    "payments_table_unavailable": "Payments table unavailable.",
    "value0_unapplied_member_payments_remain": "{value0} unapplied member payments remain.",
    "no_unapplied_member_payments_remain": "No unapplied member payments remain.",
    "clearing_account_balance_helper_is_not_available": "Clearing account balance helper is not available.",
    "value0_readiness_source_is_not_implemented_yet": "{value0} readiness source is not implemented yet.",
    "value0_source_table_is_unavailable": "{value0} source table is unavailable.",
    "value0_value1_records_need_posting_or_settlement_review": "{value0} {value1} records need posting or settlement review.",
    "open_module": "Open module",
    "value0_revenue_appears_settled_for_the_fiscal_year": "{value0} revenue appears settled for the fiscal year.",
    "value0_table_unavailable": "{value0} table unavailable.",
    "value0_records_are_still_draft_or_unposted": "{value0} records are still draft or unposted.",
    "check_skipped_because_supporting_tables_are_unavailable_in_this_environment": "Check skipped because supporting tables are unavailable in this environment.",
    "paid_value0_bills_updated_value1": "Paid {value0} · Bills updated: {value1}",
    "allocated_value0_unapplied_value1": "Allocated {value0} · Unapplied {value1}",
    "value0_must_be_a_positive_number": "{value0} must be a positive number.",
    "value0_transactionvalue1_updated": "Updated transactions: {value0}.",
    "imported_value0_rows_skipped_value1_duplicates": "Imported {value0} rows. Skipped {value1} duplicates.",
    "value0_has_been_closed": "{value0} has been closed.",
    "value0_has_been_locked": "{value0} has been locked.",
    "maximum_refundable_amount_is_value0": "Maximum refundable amount is {value0}.",
    "unable_to_resolve_this_value0_booking_source": "Unable to resolve this {value0} booking source.",
    "fiscal_year_value0_closed": "Fiscal year {value0} closed",
    "employment_details_could_not_be_saved": "Employment details could not be saved.",
    "pay_and_rate_details_could_not_be_saved": "Pay and rate details could not be saved.",
    "payment_details_could_not_be_saved": "Payment details could not be saved.",
    "tax_ni_readiness_could_not_be_saved": "Tax / NI readiness could not be saved.",
    "pension_details_could_not_be_saved": "Pension details could not be saved.",
    "action_failed": "Action failed.",
    "confirmed": "confirmed",
    "loading_2": "loading",
    "images_must_be_5_mb_or_less": "Images must be 5 MB or less.",
    "tennis": "Tennis",
    "padel": "Padel",
    "pickleball": "Pickleball",
    "squash": "Squash",
    "closed_2": "closed",
    "club_member": "Club Member",
    "staff_member_3": "Staff Member",
    "created_2": "created",
    "units": "units",
    "posted_3": "posted",
    "void_2": "void",
    "error": "error",
    "queued": "queued",
    "matched_2": "matched",
    "approved": "approved",
    "complete": "complete",
    "processing_2": "processing",
    "ready_2": "ready",
    "too_large": "too large",
    "uncategorized": "Uncategorized",
    "primary_contact_2": "Primary Contact",
    "contract": "Contract",
    "s": "s",
    "original_2": "original",
    "reset": "reset",
    "unknown_time": "unknown time",
    "voicemail": "Voicemail",
    "polo": "Polo",
    "facilities_2": "facilities",
    "weddings": "Weddings",
    "off": "off",
    "apply_uk_tax_defaults": "Apply UK tax defaults",
    "unknown_2": "unknown",
    "edit_2": "edit",
    "view_2": "view",
    "extension": "Extension",
    "unable_to_save_business_hours": "Unable to save business hours",
    "unable_to_load_hold_audio": "Unable to load hold audio",
    "recording_policy": "Recording Policy",
    "ivr": "IVR",
    "ring_all": "Ring All",
    "untitled_ivr": "Untitled IVR",
    "untitled_queue": "Untitled Queue",
    "queue": "Queue",
    "value_2": "value",
    "answered": "answered",
    "name_is_required": "Name is required",
    "booked": "booked",
    "removed": "removed",
    "unchanged": "unchanged",
    "unable_to_resolve_attendee_pricing": "Unable to resolve attendee pricing.",
    "guest_name_is_required_2": "Guest name is required.",
    "guest_email_is_required": "Guest email is required.",
    "guest_phone_is_required": "Guest phone is required.",
    "for": "For",
    "weddings_2": "weddings",
    "expires": "Expires",
    "guest_4": "guest",
    "rooms": "rooms",
    "hotel_rooms": "Hotel / Rooms",
    "front_desk_checkin_kiosk": "Front Desk Check-in Kiosk",
    "selected_room": "selected room",
    "gross_payroll_amount": "Gross payroll: {amount}",
    "variance_vs_previous_month_amount": "Variance vs previous month: {amount}",
    "department_name": "Department: {name}",
    "employee_count_count": "Employee count: {count}",
    "percentage_of_payroll_percent": "Percentage of payroll: {percent}%",
    "imported_draft_timesheets_count": "Imported draft timesheets: {count}.",
    "payslips_portal_publish_complete_published_published_existing_already_published_skipped": "Payslips portal publish complete: {published} published, {existing} already published, {skipped} skipped because no individual PDF is available.",
    "move_this_payroll_run_back_to_stage_finance_previews_may": "Move this payroll run back to {stage}? Finance previews may be cleared.",
    "payroll_defaults_refreshed_jurisdiction_jurisdiction_created_created_updated_updated_preserved": "Payroll defaults refreshed. Jurisdiction: {jurisdiction}. Created: {created}; updated: {updated}; preserved: {preserved}; reset: {reset}. Customisations are preserved unless the selected rule is reset.",
    "x_days_after_period_end": "X days after period end",
    "resolve_open_blockers_before_posting_to_accounting": "Resolve open blockers before posting to accounting.",
    "vat_gl_mappings_verified": "VAT GL mappings verified",
    "preview_only_2": "preview only",
    "current_period_3": "current period"
  },
  "paymentMethods": {
    "cash": "Cash",
    "card": "Card",
    "bank_transfer": "Bank transfer",
    "check": "Cheque",
    "ach": "ACH",
    "wire": "Wire transfer",
    "other": "Other",
    "apple_pay": "Apple Pay",
    "google_pay": "Google Pay"
  },
  "errors": {
    "invalid_amount": "Enter an amount greater than zero.",
    "invalid_payment_amount": "Enter a valid payment amount greater than zero.",
    "invalid_payment_method": "Select a supported payment method.",
    "invalid_payload": "Check the selected club and accounting record, then try again.",
    "forbidden": "You do not have permission to perform this accounting action.",
    "club_not_found": "The selected club could not be found. Select the club again.",
    "receivable_not_found": "This receivable is unavailable. Refresh the account history before retrying.",
    "usage_charge_not_invoiced": "This charge has not been invoiced yet. It will become payable once the billing run generates an invoice.",
    "allocation_exceeds_balance": "The allocation exceeds the outstanding balance. Refresh the balance and reduce the allocation.",
    "allocation_exceeds_payment": "The allocations exceed the payment amount. Reduce the allocations before continuing.",
    "allocation_exceeds_credit": "The allocations exceed the available credit. Refresh the credit balance and reduce the allocations.",
    "allocation_exceeds_outstanding": "The allocation exceeds the outstanding amount. Refresh the balance and reduce the allocation.",
    "request": "Request: {id}",
    "invalid_club_code": "Check the selected club and accounting record, then try again.",
    "bank_transactions_import_failed": "The statement could not be imported. Review the file and column mapping before retrying.",
    "bank_import_preset_fetch_failed": "The bank import preset is unavailable. Retry or review the column mapping manually.",
    "bank_import_preset_save_failed": "The bank import preset is unavailable. Retry or review the column mapping manually.",
    "supplier_not_found": "Select an available supplier before continuing.",
    "invalid_supplier": "Select an available supplier before continuing.",
    "accounting_ap_payments_fetch_failed": "Supplier payments could not be loaded. Refresh the payment list.",
    "accounting_supplier_statement_failed": "The supplier statement could not be generated. Review the selected dates and retry.",
    "accounting_ap_bills_fetch_failed": "Supplier bills could not be loaded. Refresh the list before taking further action.",
    "accounting_ap_ageing_fetch_failed": "Supplier ageing could not be loaded. Refresh the ageing report.",
    "accounting_ap_ageing_detail_failed": "Supplier ageing could not be loaded. Refresh the ageing report.",
    "ap_bill_missing_lines": "Add at least one valid bill line before posting.",
    "invalid_bill_lines": "Add at least one valid bill line before posting.",
    "ap_bill_create_failed": "The supplier bill could not be created. Review the fields and check for an existing bill before retrying.",
    "accounting_ap_bill_create_failed": "The supplier bill could not be created. Review the fields and check for an existing bill before retrying.",
    "ap_bill_not_found": "One or more selected supplier bills are unavailable. Refresh the list and select them again.",
    "ap_bills_not_found": "One or more selected supplier bills are unavailable. Refresh the list and select them again.",
    "invalid_bill_ids": "One or more selected supplier bills are unavailable. Refresh the list and select them again.",
    "ap_bill_locked": "This supplier bill cannot be changed in its current state. Review its posting and payment history.",
    "invalid_bill_status": "This supplier bill cannot be changed in its current state. Review its posting and payment history.",
    "accounting_ap_bill_fetch_failed": "The supplier bill could not be loaded. Refresh the bill details.",
    "ap_bill_void_failed": "The supplier bill could not be voided. Review its allocations and posting state.",
    "ap_payment_create_failed": "The supplier payment could not be recorded. Check existing payments before retrying.",
    "no_outstanding_balance": "There is no outstanding balance to settle. Refresh the selected records.",
    "invalid_allocation": "Review the selected allocation targets and amounts before continuing.",
    "invalid_allocation_target": "Review the selected allocation targets and amounts before continuing.",
    "ap_payment_not_found": "This payment is unavailable. Refresh the payment history.",
    "payment_not_found": "This payment is unavailable. Refresh the payment history.",
    "ap_refund_create_failed": "The refund could not be recorded. Check the payment history before retrying.",
    "refund_payment_create_failed": "The refund could not be recorded. Check the payment history before retrying.",
    "accounting_settings_fetch_failed": "Review the accounting settings and selected control, revenue and payment accounts.",
    "invalid_accounting_settings_value": "Review the accounting settings and selected control, revenue and payment accounts.",
    "invalid_accounting_settings_accounts": "Review the accounting settings and selected control, revenue and payment accounts.",
    "invalid_fiscal_year_start_month": "Select a fiscal-year starting month from 1 to 12.",
    "tax_profile_fetch_failed": "The tax configuration could not be loaded or saved. Review the club tax settings and retry.",
    "tax_profile_update_failed": "The tax configuration could not be loaded or saved. Review the club tax settings and retry.",
    "tax_defaults_apply_failed": "The tax configuration could not be loaded or saved. Review the club tax settings and retry.",
    "tax_codes_fetch_failed": "The tax code operation could not be completed. Review the tax code and its references before retrying.",
    "tax_codes_create_failed": "The tax code operation could not be completed. Review the tax code and its references before retrying.",
    "tax_codes_update_failed": "The tax code operation could not be completed. Review the tax code and its references before retrying.",
    "tax_codes_delete_failed": "The tax code operation could not be completed. Review the tax code and its references before retrying.",
    "invalid_tax_rate": "Enter a valid tax rate without changing the intended tax treatment.",
    "invalid_effective_dates": "The effective end date must not precede the effective start date.",
    "invalid_category": "Select an available tax category.",
    "tax_code_exists": "This tax code already exists. Choose a unique code.",
    "tax_code_not_found": "This tax code is unavailable. Refresh the list of tax codes.",
    "invoice_layout_fetch_failed": "The invoice layout could not be loaded or saved. Review its settings and retry.",
    "invoice_layout_save_failed": "The invoice layout could not be loaded or saved. Review its settings and retry.",
    "invalid_billing_email": "Enter a valid billing email address or leave it blank.",
    "invalid_accent_hex_color": "Enter a valid HEX accent colour.",
    "member_not_found": "The member or member account is unavailable. Refresh the member selection.",
    "member_account_not_found": "The member or member account is unavailable. Refresh the member selection.",
    "member_membership_type_missing": "Set a membership type for this member before enrolling them.",
    "membership_type_frequency_ambiguous": "Choose an explicit billing frequency during enrolment.",
    "membership_type_dues_required": "Enter a dues amount greater than zero, or configure the membership-type dues.",
    "membership_type_frequency_required": "Select a monthly, quarterly or annual frequency before activating recurring billing.",
    "membership_type_quarterly_dues_unsupported": "Enter an explicit quarterly amount or use a monthly or annual term.",
    "missing_vat_gl_account": "Configure the Output VAT GL Account for the affected tax codes before posting.",
    "journal_entry_create_failed": "The journal could not be created. Check the posting history and mappings before retrying.",
    "missing_recipient_email": "Set a recipient email address before sending the invoice.",
    "missing_resend_api_key": "Email delivery is not configured. The invoice remains available; contact an administrator.",
    "statement_total_zero": "There are no billable outstanding amounts for this statement. Review the selected period.",
    "invoice_create_failed": "The invoice could not be generated. Check the invoice list before retrying to avoid duplication.",
    "generate_invoice_failed": "The invoice could not be generated. Check the invoice list before retrying to avoid duplication.",
    "recurring_billing_settings_fetch_failed": "Recurring billing settings could not be loaded or saved. Review the settings and retry.",
    "recurring_billing_settings_update_failed": "Recurring billing settings could not be loaded or saved. Review the settings and retry.",
    "recurring_billing_runs_fetch_failed": "The billing run could not be loaded. Refresh the run list or details.",
    "recurring_billing_run_detail_failed": "The billing run could not be loaded. Refresh the run list or details.",
    "run_not_found": "This run is unavailable. Refresh the run list.",
    "payroll_run_not_found": "This run is unavailable. Refresh the run list.",
    "invalid_payment_date": "Enter a valid payment date.",
    "record_run_payments_failed": "Run payments could not be recorded. Review the payment history before retrying.",
    "recurring_billing_templates_fetch_failed": "Billing enrolments could not be loaded or updated. Refresh the selection and retry only the failed items.",
    "recurring_billing_enrollments_fetch_failed": "Billing enrolments could not be loaded or updated. Refresh the selection and retry only the failed items.",
    "recurring_billing_enrollments_bulk_failed": "Billing enrolments could not be loaded or updated. Refresh the selection and retry only the failed items.",
    "invalid_period": "Select a valid billing period.",
    "invalid_billing_period": "Select a valid billing period.",
    "recurring_billing_member_detail_fetch_failed": "The member billing preview could not be loaded. Refresh the selected statement.",
    "recurring_billing_invoice_preview_failed": "The member billing preview could not be loaded. Refresh the selected statement.",
    "recurring_billing_current_run_preview_failed": "The member billing preview could not be loaded. Refresh the selected statement.",
    "generate_and_send_invoice_failed": "Invoice generation or delivery failed. Check Invoicing and the delivery status before retrying.",
    "generate_club_run_failed": "The club billing run could not finish. Review the generated invoices and per-member failures before retrying.",
    "recurring_billing_run_due_failed": "The club billing run could not finish. Review the generated invoices and per-member failures before retrying.",
    "charge_cannot_change_billing_run": "This charge cannot move to another billing run in its current state.",
    "charge_not_found": "This charge is unavailable. Refresh the statement.",
    "charge_billing_run_update_failed": "The billing placement of this charge could not be updated. Refresh the statement before retrying.",
    "charge_exclude_failed": "The billing placement of this charge could not be updated. Refresh the statement before retrying.",
    "charge_defer_failed": "The billing placement of this charge could not be updated. Refresh the statement before retrying.",
    "charge_include_failed": "The billing placement of this charge could not be updated. Refresh the statement before retrying.",
    "confirmation_required": "Complete the required confirmation before continuing.",
    "recurring_template_validation_failed": "Review the recurring template, positive dues amount, active state and billing frequency.",
    "template_not_found": "Review the recurring template, positive dues amount, active state and billing frequency.",
    "template_not_active": "Review the recurring template, positive dues amount, active state and billing frequency.",
    "accounting_invoices_fetch_failed": "The invoice could not be loaded or downloaded. Refresh the invoice list and retry.",
    "accounting_invoice_fetch_failed": "The invoice could not be loaded or downloaded. Refresh the invoice list and retry.",
    "invoice_download_failed": "The invoice could not be loaded or downloaded. Refresh the invoice list and retry.",
    "invoice_not_found": "This invoice is unavailable. Refresh the invoice list.",
    "invoice_not_editable": "This invoice cannot be edited in its current state. Use the existing credit-note or reversal workflow where appropriate.",
    "invalid_invoice_status": "This invoice cannot be edited in its current state. Use the existing credit-note or reversal workflow where appropriate.",
    "missing_invoice_currency": "The invoice has no currency. Review its source configuration before posting.",
    "invoice_missing_lines": "Add valid invoice lines before posting.",
    "missing_accounting_settings": "Complete the required accounting control accounts and revenue/payroll mappings before posting.",
    "missing_mappings": "Complete the required accounting control accounts and revenue/payroll mappings before posting.",
    "missing_tax_code_on_taxable_line": "Select an effective tax code for every taxable line before posting.",
    "invoice_amount_mismatch": "Invoice totals do not match the source lines. Refresh and review the lines before posting.",
    "journal_not_balanced": "Debits and credits do not balance. Review the journal lines and mappings before posting.",
    "payroll_finance_preview_not_balanced": "Debits and credits do not balance. Review the journal lines and mappings before posting.",
    "refund_exceeds_allocated_amount": "The refund exceeds the refundable amount. Refresh the payment and review its allocations before reducing the refund.",
    "refund_exceeds_total_refundable": "The refund exceeds the refundable amount. Refresh the payment and review its allocations before reducing the refund.",
    "refund_exceeds_invoice_amount": "The refund exceeds the refundable amount. Refresh the payment and review its allocations before reducing the refund.",
    "refund_exceeds_unapplied_amount": "The refund exceeds the refundable amount. Refresh the payment and review its allocations before reducing the refund.",
    "invalid_bank_account": "Select an available bank account with the required GL mapping.",
    "payment_create_failed": "The payment could not be recorded. Review existing payments before retrying.",
    "accounting_member_summary_failed": "Receivables could not be loaded. Refresh the receivables list before continuing.",
    "receivables_summary_fetch_failed": "Receivables could not be loaded. Refresh the receivables list before continuing.",
    "receivables_fetch_failed": "Receivables could not be loaded. Refresh the receivables list before continuing.",
    "receivable_fetch_failed": "Receivables could not be loaded. Refresh the receivables list before continuing.",
    "member_ar_backfill_failed": "The member account could not be loaded. Refresh the account and check its history before continuing.",
    "member_ar_accounts_fetch_failed": "The member account could not be loaded. Refresh the account and check its history before continuing.",
    "member_ar_summary_fetch_failed": "The member account could not be loaded. Refresh the account and check its history before continuing.",
    "member_ar_account_resolve_failed": "The member account could not be loaded. Refresh the account and check its history before continuing.",
    "member_ar_transactions_fetch_failed": "The member account could not be loaded. Refresh the account and check its history before continuing.",
    "member_ar_open_invoices_fetch_failed": "The member account could not be loaded. Refresh the account and check its history before continuing.",
    "source_not_found": "The originating transaction is unavailable. Review the source reference or contact an administrator.",
    "source_resolve_failed": "The originating transaction is unavailable. Review the source reference or contact an administrator.",
    "member_statement_fetch_failed": "The member statement could not be loaded or generated. Review the date range and retry.",
    "member_statement_generate_failed": "The member statement could not be loaded or generated. Review the date range and retry.",
    "invoice_not_allocatable": "The selected invoice or receivable cannot receive this allocation. Refresh its outstanding balance and state.",
    "receivable_not_allocatable": "The selected invoice or receivable cannot receive this allocation. Refresh its outstanding balance and state.",
    "invalid_invoice_ids": "The selected invoice or receivable cannot receive this allocation. Refresh its outstanding balance and state.",
    "invoice_not_open": "The selected invoice or receivable cannot receive this allocation. Refresh its outstanding balance and state.",
    "invalid_parent_payment": "Select the original payment eligible for this refund.",
    "invoice_required": "Select the applicable invoice before creating the credit note.",
    "credit_note_requires_invoice": "Select the applicable invoice before creating the credit note.",
    "credit_note_exceeds_invoice_amount": "The credit exceeds the available amount. Refresh the invoice or credit balance and reduce the amount.",
    "credit_exceeds_available": "The credit exceeds the available amount. Refresh the invoice or credit balance and reduce the amount.",
    "credit_note_missing_lines": "Add at least one valid credit-note line.",
    "credit_note_create_failed": "The credit note operation failed. Refresh the credit-note list and review the invoice before retrying.",
    "credit_notes_fetch_failed": "The credit note operation failed. Refresh the credit-note list and review the invoice before retrying.",
    "credit_note_fetch_failed": "The credit note operation failed. Refresh the credit-note list and review the invoice before retrying.",
    "credit_note_not_found": "The selected credit note or credit is unavailable. Refresh the account.",
    "credit_not_found": "The selected credit note or credit is unavailable. Refresh the account.",
    "invalid_credit_note_status": "This credit note cannot be used in its current state. Review its posting and application history.",
    "credit_note_void_not_allowed": "This credit note cannot be used in its current state. Review its posting and application history.",
    "credit_note_not_posted": "This credit note cannot be used in its current state. Review its posting and application history.",
    "credit_note_void_failed": "The credit note could not be voided. Review its applications before retrying.",
    "credit_application_create_failed": "The credit application cannot be changed as requested. Refresh its current state before retrying.",
    "credit_application_not_found": "The credit application cannot be changed as requested. Refresh its current state before retrying.",
    "credit_application_already_void": "The credit application cannot be changed as requested. Refresh its current state before retrying.",
    "credit_application_not_applied": "The credit application cannot be changed as requested. Refresh its current state before retrying.",
    "period_locked": "This posting date falls in a locked or closed period. Change the date or request an authorised unlock.",
    "gl_period_locked": "This posting date falls in a locked or closed period. Change the date or request an authorised unlock.",
    "locked_period": "This posting date falls in a locked or closed period. Change the date or request an authorised unlock.",
    "period_closed": "This posting date falls in a locked or closed period. Change the date or request an authorised unlock.",
    "payroll_request_failed": "The payroll request failed. Refresh the run and review its state before retrying.",
    "invalid_id": "The selected payroll record is unavailable. Refresh the selection.",
    "not_found": "The selected payroll record is unavailable. Refresh the selection.",
    "profile_not_found": "The selected payroll record is unavailable. Refresh the selection.",
    "department_not_found": "The selected payroll record is unavailable. Refresh the selection.",
    "name_required": "Enter a name before saving.",
    "unsupported_payment_jurisdiction": "Payment details are not supported for the configured jurisdiction. Review payroll settings.",
    "replacement_reason_required": "Enter a reason before replacing payment details.",
    "invalid_rate_type": "Choose a supported rate type or status before saving.",
    "invalid_status": "Choose a supported rate type or status before saving.",
    "invalid_verification_status": "Choose a supported rate type or status before saving.",
    "payment_details_not_found": "Save payment details before verifying them.",
    "timesheet_locked": "This timesheet is locked. Use the authorised reopen workflow before editing.",
    "timesheet_lines_required": "Add valid timesheet lines or the required zero-hours explanation.",
    "zero_hours_note_required": "Add valid timesheet lines or the required zero-hours explanation.",
    "run_not_recalculable": "This payroll run cannot be changed in its current state. Review the authorised rollback or reopen actions.",
    "run_not_mutable": "This payroll run cannot be changed in its current state. Review the authorised rollback or reopen actions.",
    "payroll_not_editable": "This payroll run cannot be changed in its current state. Review the authorised rollback or reopen actions.",
    "payroll_locked": "This payroll run cannot be changed in its current state. Review the authorised rollback or reopen actions.",
    "payroll_period_id_required": "Select an available open payroll period.",
    "period_not_found": "Select an available open payroll period.",
    "period_not_open": "Select an available open payroll period.",
    "duplicate_active_run": "An active run already exists for this period. Open the existing run instead of creating a duplicate.",
    "blocker_not_found": "This blocker or decision is no longer available. Refresh the payroll review.",
    "decision_not_allowed": "This blocker or decision is no longer available. Refresh the payroll review.",
    "provider_deductions_not_required": "Provider deductions are not required in this payroll mode. Review the configured statutory source.",
    "no_payroll_run_lines": "Refresh the calculated employee lines before saving statutory inputs.",
    "duplicate_payroll_run_line_id": "Refresh the calculated employee lines before saving statutory inputs.",
    "unknown_payroll_run_line_id": "Refresh the calculated employee lines before saving statutory inputs.",
    "legacy_run_level_statutory_totals": "Run-level statutory totals are not employee payslips. Enter employee-level values before generating final payslips.",
    "statutory_inputs_stale": "Payroll was recalculated after statutory values were saved. Review and re-enter employee statutory inputs.",
    "payroll_run_not_review_stage": "Move the payroll run to its review stage before entering statutory values.",
    "payroll_blockers_unresolved": "Resolve the payroll blockers before moving to the next stage.",
    "run_has_blockers": "Resolve the payroll blockers before moving to the next stage.",
    "employee_statutory_rows_missing": "Complete PAYE, Employee NI and Employer NI for every included employee before continuing.",
    "employee_statutory_row_missing": "Complete PAYE, Employee NI and Employer NI for every included employee before continuing.",
    "payroll_line_incomplete": "Complete PAYE, Employee NI and Employer NI for every included employee before continuing.",
    "employee_statutory_row_incomplete": "Complete PAYE, Employee NI and Employer NI for every included employee before continuing.",
    "payroll_line_final_values_missing": "Complete PAYE, Employee NI and Employer NI for every included employee before continuing.",
    "payslip_totals_do_not_reconcile": "Payslip totals do not reconcile with payroll. Review the employee statutory values and run totals.",
    "invalid_status_transition": "This payroll stage change is not allowed. Refresh the run and use its available next action.",
    "finance_posting_required": "Post the payroll journal to accounting before recording payment.",
    "gl_post_required": "Post the payroll journal to accounting before recording payment.",
    "payroll_not_ready_to_lock": "Complete finance posting, payables and staff payment before locking payroll.",
    "provider_deductions_required": "Enter the required provider-supplied statutory values before continuing.",
    "payroll_already_posted": "Payroll is already posted. Review the existing journal and use authorised reversal actions where available.",
    "tenant_schema_out_of_date": "The club database is not ready for this payroll operation. Contact support with the request reference.",
    "payslip_snapshot_locked": "Issued payslip snapshots are locked and cannot be silently regenerated.",
    "final_payslips_pdf_not_ready": "Generate valid individual final payslip PDFs before publishing to the staff portal.",
    "invalid_calculation_mode": "Review the payroll calculation mode, frequency and calendar dates before saving.",
    "invalid_payroll_frequency": "Review the payroll calculation mode, frequency and calendar dates before saving.",
    "invalid_default_payment_day": "Review the payroll calculation mode, frequency and calendar dates before saving.",
    "invalid_approval_deadline_days": "Review the payroll calculation mode, frequency and calendar dates before saving.",
    "invalid_next_run_date": "Review the payroll calculation mode, frequency and calendar dates before saving.",
    "accounting_reports_fetch_failed": "The report operation could not be completed. Refresh the saved reports and review the configuration.",
    "accounting_reports_create_failed": "The report operation could not be completed. Refresh the saved reports and review the configuration.",
    "accounting_reports_update_failed": "The report operation could not be completed. Refresh the saved reports and review the configuration.",
    "accounting_reports_delete_failed": "The report operation could not be completed. Refresh the saved reports and review the configuration.",
    "missing_budget_version": "Select an available budget and version before running this report.",
    "missing_budget_params": "Select an available budget and version before running this report.",
    "budget_not_found": "Select an available budget and version before running this report.",
    "report_not_found": "This report is unavailable or its type is unsupported. Select a supported report.",
    "report_type_not_supported": "This report is unavailable or its type is unsupported. Select a supported report.",
    "invalid_date_range": "Enter a valid start and end date in the correct order.",
    "accounting_gl_month_end_tasks_fetch_failed": "The month-end checklist could not be loaded. Refresh the period before continuing.",
    "invalid_entry_class": "Select a supported journal entry class for this exception.",
    "member_receivables_balance_unresolved": "The member’s receivable balance could not be resolved. Refresh the member account before allocating a payment.",
    "payroll_payment_encryption_config_invalid": "Payroll bank details cannot be securely processed. Ask an administrator to check the payroll encryption configuration before retrying.",
    "payroll_payment_kms_client_unavailable": "Payroll bank details cannot be securely processed. Ask an administrator to check the payroll encryption configuration before retrying.",
    "payroll_payment_kms_key_not_configured": "Payroll bank details cannot be securely processed. Ask an administrator to check the payroll encryption configuration before retrying.",
    "payroll_payment_kms_data_key_failed": "Payroll bank details cannot be securely processed. Ask an administrator to check the payroll encryption configuration before retrying.",
    "payroll_payment_kms_decrypt_failed": "Payroll bank details cannot be securely processed. Ask an administrator to check the payroll encryption configuration before retrying.",
    "account_holder_name_required": "Enter the bank account holder’s name.",
    "invalid_sort_code": "Enter a valid six-digit UK sort code.",
    "invalid_account_number": "Enter a valid bank account number for the selected payment scheme.",
    "invalid_routing_number": "Enter a valid nine-digit US routing number.",
    "account_number_required": "Enter the bank account number.",
    "invalid_account_type": "Choose a supported bank account type.",
    "invalid_iban": "Enter a valid IBAN.",
    "unsupported_payment_scheme": "This payment scheme is not supported for the club’s configured jurisdiction. Review Payroll Settings.",
    "payment_file_decryption_not_wired_until_approved_run_generation": "Bank-file decryption is available only during approved payroll-run generation. Approve the run before generating the file.",
    "invalid_billable_recurring_receivables_args": "Select a valid club, member and billing period, then reload the statement.",
    "invalid_current_statement_args": "Select a valid club, member and billing period, then reload the statement.",
    "tax_code_required": "Select a tax code for every taxable line before posting.",
    "invalid_tax_code": "A selected tax code is invalid or unavailable for the posting date. Review the affected lines and tax-code configuration.",
    "unsupported_revenue_source": "This revenue source does not support the requested posting. Open its source transaction and review the supported workflow.",
    "posting_source_not_found": "The source transaction for this posting was not found. Refresh the source record before retrying.",
    "original_batch_not_found": "The original posting batch could not be found. Review the source journal before requesting a reversal."
  },
  "documents": {
    "invoice": "Invoice",
    "date": "Date {date}",
    "due": "Due {date}",
    "billedTo": "Billed To",
    "member": "Member",
    "club": "Club",
    "description": "Description",
    "quantity": "Qty",
    "unit": "Unit",
    "total": "Total",
    "charge": "Charge",
    "subtotal": "Subtotal",
    "tax": "Tax",
    "amountDue": "Amount Due",
    "thankYou": "Thank you for your business!",
    "greeting": "Hello {name},",
    "attached": "Your latest invoice from {club} is attached.",
    "ready": "Your recurring billing invoice {number} is ready.",
    "amount": "Amount: {amount}",
    "dueDate": "Due date: {date}",
    "contact": "If you have any questions, please contact {club} at {contact}.",
    "thanks": "Thank you,",
    "subject": "Invoice from {club} – {number}",
    "subjectWithoutNumber": "Your invoice from {club}",
    "unavailable": "Not available",
    "draft": "DRAFT",
    "payslipPayslip": "Payslip",
    "payslipEmployee": "Employee",
    "payslipReference": "Reference",
    "payslipJobtitle": "Job title",
    "payslipDepartment": "Department",
    "payslipPayrollrun": "Payroll run",
    "payslipPayrollsourcereference": "Payroll source/reference",
    "payslipPayment": "Payment",
    "payslipEarnings": "Earnings",
    "payslipBasepaysalary": "Base pay / salary",
    "payslipOvertimepay": "Overtime pay",
    "payslipHolidaypay": "Holiday pay",
    "payslipSickpay": "Sick pay",
    "payslipGrosspay": "Gross pay",
    "payslipDeductions": "Deductions",
    "payslipPAYEIncomeTax": "PAYE Income Tax",
    "payslipEmployeeNationalInsurance": "Employee National Insurance",
    "payslipEmployeePension": "Employee Pension",
    "payslipOtherEmployeeDeductions": "Other Employee Deductions",
    "payslipTotalDeductions": "Total Deductions",
    "payslipNetpay": "Net pay",
    "payslipEmployercontributions": "Employer contributions",
    "payslipEmployerNationalInsurance": "Employer National Insurance",
    "payslipEmployerPension": "Employer Pension",
    "payslipOtherEmployerCosts": "Other Employer Costs",
    "payslipTotalEmployerContributions": "Total Employer Contributions",
    "payslipThisisyourpayslipfortheperiodshownabove": "This is your payslip for the period shown above.",
    "payslipPeriod": "Pay period {start} to {end}",
    "payslipPayDate": "Pay date {date}",
    "payslipBank": "Bank transfer ending {last4}",
    "payslipTitle": "{run} payslip"
  },
  "lifecycle": {
    "included": "Included in {run}",
    "paidVia": "Paid via {source}",
    "billingRun": "Billing Run: {run}",
    "settledBy": "Settled by {source}"
  },
  "debtorTypes": {
    "member": "Member",
    "guest": "Guest",
    "ad_hoc": "Ad-hoc",
    "supplier": "Supplier",
    "company": "Company"
  },
  "confirmations": {
    "yearEnd": "This closes the fiscal year and cannot be duplicated. Type {confirmation} to confirm."
  },
  "batch": {
    "memberResult": "Member {member}: skipped items: {skipped}; mapped items: {mapped}.",
    "failure": "Member {member}: {reason}",
    "recovery": "Review generated invoices and each member failure before retrying."
  },
  "csv": {
    "column": "Column {number}",
    "parse": "The CSV could not be parsed. Check the quotes and column counts.",
    "quotes": "The CSV contains invalid quotes. Check row {row}.",
    "delimiter": "The CSV delimiter could not be detected. Review the file.",
    "fields": "The field count does not match the columns in row {row}.",
    "read": "The CSV file could not be read. Select a valid file.",
    "date": "Row {row}: invalid date value.",
    "description": "Row {row}: missing description.",
    "amount": "Row {row}: invalid amount."
  },
  "enums": {
    "accountType": {
      "asset": "Asset",
      "liability": "Liability",
      "equity": "Equity",
      "revenue": "Revenue",
      "expense": "Expense"
    },
    "period": {
      "open": "Open",
      "closed": "Closed",
      "locked": "Locked",
      "ready": "Ready",
      "blocked": "Blocked",
      "pass": "Passed",
      "fail": "Failed",
      "warning": "Warning",
      "not_applicable": "Not applicable"
    },
    "payment": {
      "received": "Received",
      "paid": "Paid",
      "pending": "Pending",
      "failed": "Failed",
      "completed": "Completed",
      "refunded": "Refunded",
      "partially_refunded": "Partially refunded",
      "void": "Void",
      "voided": "Voided",
      "allocated": "Allocated",
      "unapplied": "Unapplied",
      "partially_applied": "Partially applied",
      "fully_applied": "Fully applied"
    },
    "source": {
      "membership_dues": "Membership dues",
      "membership": "Membership",
      "pos": "Dining & Bar",
      "dining": "Dining & Bar",
      "bar": "Dining & Bar",
      "events": "Events",
      "golf": "Golf",
      "spa": "Spa",
      "fitness": "Fitness",
      "polo": "Polo",
      "marina": "Marina",
      "racquet": "Racquet",
      "hotel": "Hotel",
      "rooms": "Hotel / Rooms",
      "lessons": "Lessons",
      "pro_shop": "Retail / Pro Shop",
      "retail": "Retail / Pro Shop",
      "weddings": "Weddings",
      "member_account": "Member account",
      "invoice": "Invoice",
      "charge": "Charge",
      "ad_hoc": "Ad-hoc",
      "supplier": "Supplier",
      "member": "Member",
      "guest": "Guest",
      "payroll": "Payroll"
    },
    "frequency": {
      "weekly": "Weekly",
      "fortnightly": "Fortnightly",
      "monthly": "Monthly",
      "quarterly": "Quarterly",
      "annual": "Annual",
      "annually": "Annually",
      "yearly": "Yearly"
    },
    "payroll": {
      "draft": "Draft",
      "review": "Review",
      "calculated": "Calculated",
      "awaiting_approval": "Awaiting approval",
      "approved": "Approved",
      "posted": "Posted",
      "paid": "Paid",
      "locked": "Locked",
      "ready": "Ready",
      "active": "Active",
      "inactive": "Inactive",
      "missing_details": "Missing details",
      "on_hold": "On hold",
      "leaver": "Leaver",
      "verified": "Verified",
      "unverified": "Unverified",
      "pending": "Pending",
      "missing": "Missing",
      "not_ready": "Not ready",
      "preview_ready": "Preview ready",
      "not_required": "Not required",
      "enrolled": "Enrolled",
      "opted_out": "Opted out",
      "salary": "Salary",
      "hourly": "Hourly",
      "casual": "Casual",
      "contractor": "Contractor",
      "hybrid": "Salary + adjustments",
      "submitted": "Submitted",
      "rejected": "Rejected",
      "regular": "Regular",
      "overtime": "Overtime",
      "holiday": "Holiday",
      "sick": "Sick",
      "training": "Training",
      "adjustment": "Adjustment",
      "checking": "Checking",
      "savings": "Savings",
      "fixed_day_of_month": "Fixed day of month",
      "last_day_of_month": "Last day of month",
      "last_working_day_of_month": "Last working day of month",
      "days_after_period_end": "Days after period end"
    },
    "billing": {
      "not_enrolled": "Not enrolled",
      "enrolled": "Enrolled",
      "active": "Active",
      "paused": "Paused",
      "unbilled": "Unbilled",
      "invoiced": "Invoiced",
      "draft": "Draft",
      "pending": "Pending",
      "issued": "Issued",
      "posted": "Posted",
      "open": "Open",
      "paid": "Paid",
      "part_paid": "Part paid",
      "partially_paid": "Partially paid",
      "overdue": "Overdue",
      "sent": "Sent",
      "failed": "Failed",
      "skipped": "Skipped",
      "scheduled": "Scheduled",
      "excluded": "Excluded",
      "deferred": "Deferred",
      "generated": "Generated",
      "included_current": "Included in current billing run",
      "included_future": "Included in future billing run",
      "latest_dues_invoice_paid": "Latest dues invoice paid",
      "latest_dues_invoice_open": "Latest dues invoice open",
      "latest_dues_invoice_overdue": "Latest dues invoice overdue",
      "projected_not_generated": "Projected, not generated"
    },
    "bank": {
      "unmatched": "Unmatched",
      "partially_matched": "Partially matched",
      "matched": "Matched",
      "reconciled": "Reconciled",
      "ignored": "Ignored"
    },
    "reportStatus": {
      "draft": "Draft",
      "open": "Open",
      "posted": "Posted",
      "paid": "Paid",
      "partially_paid": "Partially paid",
      "void": "Void",
      "refunded": "Refunded",
      "unpaid": "Unpaid",
      "overdue": "Overdue",
      "reconciled": "Reconciled",
      "pending": "Pending",
      "approved": "Approved",
      "closed": "Closed"
    }
  },
  "match": {
    "supplier": "Supplier: {name}",
    "member": "Member: {name}"
  },
  "payroll": {
    "pensionSummary": "Provider {provider} • Employee {employee} • Club {club}",
    "multiplier": "{value}x multiplier",
    "periodRange": "{name} — {start}–{end}",
    "periodRangeWithPay": "{name} — {start}–{end} — Pay {pay}"
  },
  "glMemo": {
    "memberSale": "POS sale {sale} — {member}",
    "guestSale": "POS sale {sale} — Guest",
    "sale": "POS sale {sale}",
    "golf": "Golf booking charge"
  },
  "validation": {
    "paymentRange": "Amount must be between 0 and {amount}."
  },
  "billing": {
    "itemCountOne": "{count} item",
    "itemCountOther": "{count} items",
    "currentStatement": "Current statement ({period})",
    "moveBack": "Move back to this statement",
    "nextRun": "Next billing run",
    "futureRun": "Future billing run",
    "deferredFrom": "Deferred from {period}",
    "deferredEarlier": "Deferred from earlier billing",
    "mappingWarning": "A charge has no revenue mapping (mapping key: {key}). Configure the mapping before posting.",
    "warning": "Review this billing warning before continuing."
  },
  "final": {
    "rows": "Rows",
    "schedule": "Schedule",
    "saveSettings": "Save Settings",
    "required": "Required",
    "yearReadiness": "{year} readiness"
  },
  "yearEnd": {
    "closedBy": "Year-end closed on {date} by {person}",
    "closed": "Year-end closed on {date}"
  },
  "payrollExceptions": {
    "missing_calendar": {
      "title": "Missing payroll calendar",
      "description": "Assign this active employee to a payroll calendar."
    },
    "missing_rate": {
      "title": "Missing active rate",
      "description": "Add an active payroll rate covering this pay period."
    },
    "profile_readiness": {
      "title": "Profile readiness blocker",
      "description": "Review the employee’s bank, tax and pension details."
    },
    "missing_approved_timesheet": {
      "title": "Missing approved timesheet",
      "description": "Approve the employee’s timesheet or review the permitted confirmation for this run before proceeding."
    },
    "invalid_rate": {
      "title": "Invalid fixed salary rate",
      "description": "Fixed salary and hybrid profiles need a salary rate for their fixed component."
    },
    "holiday_unpaid": {
      "title": "Holiday hours excluded",
      "description": "The current pay rules do not enable holiday pay."
    },
    "sick_unpaid": {
      "title": "Sick hours excluded",
      "description": "The current pay rules do not enable sick pay."
    },
    "missing_mapping": {
      "title": "Missing payroll journal mapping",
      "description": "Configure debit and credit accounts for this payroll cost or liability in Payroll Settings."
    },
    "provider_deductions_required": {
      "title": "Statutory inputs required",
      "description": "Review and save provider-supplied PAYE and employee/employer National Insurance amounts for every employee before approval."
    },
    "employer_social_security_review": {
      "title": "Employer NI review required",
      "description": "Review the employer contribution configuration before payroll can proceed."
    }
  },
  "timesheets": {
    "missing": "Timesheet-driven employees missing submissions for this pay period: {count}.",
    "awaiting": "Submitted timesheets awaiting approval for this pay period: {count}.",
    "overtime": "Overtime is concentrated for the selected payroll period.",
    "approved": "All submitted timesheets are approved for the selected payroll period."
  },
  "periods": {
    "closeEarlier": "Close {periods} before closing {period}.",
    "earlierRequired": "Earlier accounting periods must be closed first.",
    "fiscalMonth": "FY{year} Month {month}"
  },
  "defaults": {
    "summary": "Jurisdiction: {jurisdiction}. Revenue, VAT, payroll mappings and control accounts verified. VAT mappings updated: {tax}. Payroll policies reviewed: {policies}. Existing customisations preserved.",
    "uk": "United Kingdom",
    "us": "United States",
    "region": "Club payroll region"
  },
  "portalCategories": {
    "membership": "Membership",
    "dining": "Dining & Bar",
    "golf": "Golf",
    "spa": "Spa",
    "racquet": "Racquet",
    "fitness": "Fitness",
    "rooms": "Hotel / Rooms",
    "events": "Events",
    "other": "Other account charges"
  }
};
